export default {
  en: {
    "entity.label.Edit": "Edit",
  "entity.label.UpdateCredit": "Update Credit",
  "entity.label.AddTicket": "Add Ticket",
  "entity.label.DownloadUploadedFile": "Download Uploaded File",
  "entity.label.Close": "Close",
  "entity.label.ReopenTicket": "Reopen Ticket",
  "entity.label.ResolutionDescription": "Resolution Description",
  "entity.label.SelectCategory": "Select Category",
  "entity.label.SelectSubCategory": "Select Subcategory",
  "entity.label.description": "Description",
  "entity.label.CloseTicket": "Close Ticket",
    "entity.label.Commission": "Commission",
  "entity.label.CommisionType": "Commission Type",
  "entity.label.Configure": "Configure",
  "entity.label.Agreement": "Agreement",
  "entity.label.Type": "Type",
  "entity.label.TAP_version": "TAP version",
  "entity.label.TAP_In_sequence": "TAP In sequence",
  "entity.label.TAP_Out_sequence": "TAP Out sequence",
  "entity.label.RAP_In_Sequence": "RAP In Sequence",
  "entity.label.RAP_Out_Sequence": "RAP Out Sequence",
  "entity.label.NRTRDE_In_Sequence": "NRTRDE In Sequence",
  "entity.label.NRTRDE_Out_Sequence": "NRTRDE Out Sequence",
  "entity.label.In": "In",
  "entity.label.Plan": "Plan",
  "entity.label.Out": "Out",
  "entity.label.Cancel": "Cancel",
  "entity.label.Save": "Save",
    "entity.label.SelectSearch": "Select Search",
  "entity.label.SelectPriority": "Select Priority",
  "entity.label.SelectCategory": "Select Category",
  "entity.label.SelectSubCategory": "Select Subcategory",
  "entity.label.SelectSource": "Select Source",
    "entity.label.business_entity_transaction_history":
      "Business Entity Transaction History",
    "entity.label.edit_business_entity": "Edit Business Entity",
    "entity.label.business_entity": "Business Entity",
    "entity.label.business_entity_name": "Business Entity Name",
    "entity.label.business_entity_code": "Business Entity Code",
    "entity.label.parent_business_entity": "Parent Business Entity",
    "entity.label.business_entity_type": "Business Entity Type",
    "entity.label.opened_on": "Opened On",
    "entity.label.actions": "Actions",
    "entity.label.clear": "Clear",
    "entity.label.credit": "Credit",
    "entity.label.create_new_ticket": "Create New Ticket",
    "entity.label.cheque_no": "Cheque No",
    "entity.label.from_date": "From Date",
    "entity.label.to_date": "To Date",
    "entity.label.filter_by_date": "Filter By Date",
    "entity.label.start_date": "Start Date",
    "entity.label.end_date": "End Date",
    "entity.label.search": "Search",
    "entity.label.tree_view": "Tree View",
    "entity.label.activity_log": "Activity Log",
    "entity.label.create_business_entity": "Create Business Entity",
    "entity.label.business_entity_tree_view": "Business Entity Tree View",
    "entity.label.list_view": "List View",
    "entity.label.business_entity_opened_on": "Business Entity Opened On",
    "entity.label.relationship_type": "Relationship Type",
    "entity.label.business_entity_info": "Business Entity Info",
    "entity.label.company_info": "Company Info",
    "entity.label.done": "Done",
    "entity.label.company_reg_no": "Company Reg No",
    "entity.label.email": "Email",
    "entity.label.payment_type": "Payment Type",
    "entity.label.address_name": "Address Name",
    "entity.label.segment_type": "Segment Type",
    "entity.label.city_area": "City/Area",
    "entity.label.contact_person": "Contact Person",
    "entity.label.district": "District",
    "entity.label.phone_number": "Phone Number",
    "entity.label.state": "State",
    "entity.label.pan_card_no": "Pancard No",
    "entity.label.country": "Country",
    "entity.label.gst_reg_no": "GST Reg No",
    "entity.label.subscriber_dues": "Subscriber Dues",
    "entity.label.zip_code": "Zip Code",
    "entity.label.commission_model": "Commission Model",
    "entity.label.successfully_created_business_entity":
      "Successfully Created Business Entity",
    "entity.label.successfully_edited_business_entity":
      "Successfully Edited Business Entity",
    "entity.label.go_back_to_business_entity_list":
      "Go back to business entity list",
    "entity.label.cancel": "Cancel",
    "entity.label.previous": "Previous",
    "entity.label.next": "Next",
    "entity.label.submit": "Submit",
    "entity.label.view_business_entity": "View Business Entity",
    "entity.label.add_ticket": "Add Ticket",
    "entity.label.payments": "Payments",
    "entity.label.adjustments": "Adjustments",
    "entity.label.agreements": "Agreements",
    "entity.label.charges": "Charges",
    "entity.label.basic_information": "Basic Information",
    "entity.label.address_information": "Address Information",
    "entity.label.balance": "Balance",
    "entity.label.credit_limit": "Credit Limit",
    "entity.label.agreement_details": "Agreement Details",
    "entity.label.tickets": "Tickets",
    "entity.label.business_entity_disbursements":
      "Business Entity Disbursements",
    "entity.label.financial_transactions": "Financial Transactions",
    "entity.label.customers": "Customers",
    "entity.label.settlement": "Settlement",
    "entity.label.plan_description": "Plan Description",
    "entity.label.contract_end_date": "Contract End Date",
    "entity.label.ticket_number": "Ticket Number",
    "entity.label.priority": "Priority",
    "entity.label.ticket_date": "Ticket Date",
    "entity.label.problem_code": "Problem Code",
    "entity.label.status": "Status",
    "entity.label.title": "Title",
    "entity.label.assign_to": "Assign To",
    "entity.label.id": "ID",
    "entity.label.transaction_date": "Transaction Date",
    "entity.label.commission_amount": "Commission Amount",
    "entity.label.commission_type": "Commission Type",
    "entity.label.commission_rate": "Commission Rate",
    "entity.label.transaction_id": "Transaction ID",
    "entity.label.transaction_type": "Transaction Type",
    "entity.label.amount": "Amount",
    "entity.label.category": "Category",
    "entity.label.cancel_remark": "Cancel Remark",
    "entity.label.source": "Source",
    "entity.label.stb_number": "STB Number",
    "entity.label.customer_number": "Customer Number",
    "entity.label.name": "Name",
    "entity.label.mobile_number": "Mobile Number",
    "entity.label.order_number": "Order Number",
    "entity.label.active_date": "Active Date",
    "entity.label.expiry_date": "Expiry Date",
    "entity.label.balance_amount": "Balance Amount",
    "entity.label.roaming_settlement": "Roaming Settlement",
    "entity.label.interconnect_settlement": "Interconnect Settlement",
    "entity.label.contract_agreement": "Contract Agreement",
    "entity.label.tariff_plan_agreement": "Tariff Plan Agreement",
    "entity.label.new_ticket": "Create New Ticket",
    "entity.label.sub_category": "Sub Category",
    "entity.label.due_time": "Due Time",
    "entity.label.description": "Description",
    "entity.label.save": "Save",
    "entity.label.receipt_no": "Receipt No",
    "entity.label.payment_date": "Payment Date",
    "entity.label.create_payments": "Create Payments",
    "entity.label.collection_by": "Collection By",
    "entity.label.notes": "Notes",
    "entity.label.is_wallet": "Is Wallet",
    "entity.label.bank_name": "Bank Name",
    "entity.label.branch_name": "Branch Name",
    "entity.label.create_adjustment": "Create Adjustment",
    "entity.label.adjustment_date": "Adjustment Date",
    "entity.label.adjustment_code": "Adjustment Code",
    "entity.label.adjustment_amount": "Adjustment Amount",
    "entity.label.adjustment_type": "Adjustment Type",
    "entity.label.view_ticket": "View Ticket",
    "entity.label.close_ticket": "Close Ticket",
    "entity.label.edit_ticket": "Edit Ticket",
    "entity.label.last_comment": "Last Comment",
    "entity.label.problem_description": "Problem Description",
    "entity.label.comment_date": "Comment Date",
    "entity.label.file": "File",
    "entity.label.agreement": "Agreement",
    "entity.label.create_agreement": "Create Agreement",
    "entity.label.partner_agreement": "Partner Agreement",
    "entity.label.contract_effect_date": "Contract Effect Date",
    "entity.label.agreement_date": "Agreement Date",
    "entity.label.agreement_status": "Agreement Status",
    "entity.label.agreement_type": "Agreement Type",
    "entity.label.business_entity_details": "Business Entity Details",
    "entity.label.CancelFinancialTransaction": "Cancel Financial Transaction",
    "entity.label.CancelRemark": "Cancel Remark",
    "entity.label.Save": "Save",
    "entity.label.Cancel": "Cancel",
    "entity.label.PartnerAgreement": "Partner Agreement",
    "entity.label.ContractEffectDate": "Contract Effect Date",
    "entity.label.AgreementDate": "Adjustment Date",
    "entity.label.AgreementStatus": "Agreement Status",
    "entity.label.AgreementType": "Agreement Type",
    "entity.label.AgreementDetails": "Agreement Details",
    "entity.label.ActivityLog": "Activity Log",
    "entity.label.BusinessEntityId": "Business Entity Id",
    "entity.label.TransactionDate": "Transaction Date",
    "entity.label.TransactionType": "Transaction Type",
    "entity.label.History": "History",
    "entity.label.AdjustmentDate": "Adjustment Date",
    "entity.label.Commission": "Commission",
    "entity.label.CommissionType": "Commission Type",
    "entity.label.Value": "Value",
    "entity.label.Type": "Type",
    "entity.label.TAPVersion": "TAP version",
    "entity.label.TAPInSequence": "TAP In sequence",
    "entity.label.TAPOutSequence": "TAP Out sequence",
    "entity.label.RAPInSequence": "RAP In Sequence",
    "entity.label.RAPOutSequence": "RAP Out Sequence",
    "entity.label.NRTRDEInSequence": "NRTRDE In Sequence",
    "entity.label.NRTRDEOutSequence": "NRTRDE Out Sequence",
    "entity.label.Configure": "Configure",
    "entity.label.CancelFinancialTransaction": "Cancel Financial Transaction",
    "entity.label.cancelremark": "Cancel Remark",
    "entity.label.Create_Payment": "Create Payment",
  },

  fr: {
    "entity.label.Edit": "Modifier",
  "entity.label.UpdateCredit": "Mettre à jour le crédit",
  "entity.label.AddTicket": "Ajouter un ticket",
  "entity.label.DownloadUploadedFile": "Télécharger le fichier",
  "entity.label.Close": "Fermer",
  "entity.label.ReopenTicket": "Rouvrir le ticket",
  "entity.label.ResolutionDescription": "Description de la résolution",
  "entity.label.SelectCategory": "Sélectionner une catégorie",
  "entity.label.SelectSubCategory": "Sélectionner une sous-catégorie",
  "entity.label.description": "Description",
  "entity.label.CloseTicket": "Fermer le ticket",
    "entity.label.Commission": "Commission",
  "entity.label.CommisionType": "Type de commission",
  "entity.label.Configure": "Configurer",
  "entity.label.Agreement": "Accord",
  "entity.label.Type": "Type",
  "entity.label.TAP_version": "Version TAP",
  "entity.label.TAP_In_sequence": "Séquence TAP Entrée",
  "entity.label.TAP_Out_sequence": "Séquence TAP Sortie",
  "entity.label.RAP_In_Sequence": "Séquence RAP Entrée",
  "entity.label.RAP_Out_Sequence": "Séquence RAP Sortie",
  "entity.label.NRTRDE_In_Sequence": "Séquence NRTRDE Entrée",
  "entity.label.NRTRDE_Out_Sequence": "Séquence NRTRDE Sortie",
  "entity.label.In": "Entrée",
  "entity.label.Plan": "Plan",
  "entity.label.Out": "Sortie",
  "entity.label.Cancel": "Annuler",
  "entity.label.Save": "Sauvegarder",
    "entity.label.SelectSearch": "Sélectionner la recherche",
  "entity.label.SelectPriority": "Sélectionner la priorité",
  "entity.label.SelectCategory": "Sélectionner une catégorie",
  "entity.label.SelectSubCategory": "Sélectionner une sous-catégorie",
  "entity.label.SelectSource": "Sélectionner la source",
    "entity.label.business_entity_transaction_history":
      "Historique des transactions de l'entité commerciale",
    "entity.label.edit_business_entity": "Modifier l'entité commerciale",
    "entity.label.business_entity": "Entité commerciale",
    "entity.label.business_entity_name": "Nom de l'entité commerciale",
    "entity.label.business_entity_code": "Code d'entité commerciale",
    "entity.label.parent_business_entity": "Entité commerciale mère",
    "entity.label.business_entity_type": "Type d'entité commerciale",
    "entity.label.opened_on": "Ouvert le",
    "entity.label.actions": "Action",
    "entity.label.clear": "Effacer",
    "entity.label.credit": "Crédit",
    "entity.label.create_new_ticket": "Créer un nouveau ticket",
    "entity.label.cheque_no": "N° de chèque",
    "entity.label.from_date": "De la date",
    "entity.label.to_date": "À la date",
    "entity.label.filter_by_date": "Filtrer par date",
    "entity.label.start_date": "Date de début",
    "entity.label.end_date": "Date de fin",
    "entity.label.search": "Rechercher",
    "entity.label.tree_view": "Vue arborescente",
    "entity.label.activity_log": "Journal des activités",
    "entity.label.create_business_entity": "Créer une entité commerciale",
    "entity.label.business_entity_tree_view":
      "Vue arborescente des entités commerciales",
    "entity.label.list_view": "Vue Liste",
    "entity.label.business_entity_opened_on": "Entité commerciale ouverte le",
    "entity.label.relationship_type": "Type de Relation",
    "entity.label.business_entity_info":
      "Informations sur l'entité commerciale",
    "entity.label.company_info": "Informations sur l'entreprise",
    "entity.label.done": "Terminé",
    "entity.label.company_reg_no": "Numéro d'inscription de l'entreprise",
    "entity.label.email": "Email",
    "entity.label.payment_type": "Type de paiement",
    "entity.label.address_name": "Nom de l'adresse",
    "entity.label.segment_type": "Type de segment",
    "entity.label.city_area": "Ville/Quartier",
    "entity.label.contact_person": "Personne à contacter",
    "entity.label.district": "District",
    "entity.label.phone_number": "Numéro de téléphone",
    "entity.label.state": "État",
    "entity.label.pan_card_no": "Numéro de carte Pan",
    "entity.label.country": "Pays",
    "entity.label.gst_reg_no": "Numéro d'enregistrement GST",
    "entity.label.subscriber_dues": "Droits des abonnés",
    "entity.label.zip_code": "Code postal",
    "entity.label.commission_model": "Modèle de commission",
    "entity.label.successfully_created_business_entity":
      "Entité commerciale créée avec succès",
    "entity.label.successfully_edited_business_entity":
      "Entité commerciale modifiée avec succès",
    "entity.label.go_back_to_business_entity_list":
      "Revenir à la liste des entités commerciales",
    "entity.label.cancel": "Annuler",
    "entity.label.previous": "Précédent",
    "entity.label.next": "Suivant",
    "entity.label.submit": "Soumettre",
    "entity.label.view_business_entity": "Afficher l'entité commerciale",
    "entity.label.add_ticket": "Ajouter un ticket",
    "entity.label.payments": "Paiements",
    "entity.label.adjustments": "Ajustements",
    "entity.label.agreements": "Accords",
    "entity.label.charges": "Frais",
    "entity.label.basic_information": "Informations de base",
    "entity.label.address_information": "Informations d'adresse",
    "entity.label.balance": "Solde",
    "entity.label.credit_limit": "Limite de crédit",
    "entity.label.agreement_details": "Détails de l'accord",
    "entity.label.tickets": "Billets",
    "entity.label.business_entity_disbursements":
      "Décaissements des entités commerciales",
    "entity.label.financial_transactions": "Transactions financières",
    "entity.label.customers": "Clients",
    "entity.label.settlement": "Règlement",
    "entity.label.plan_description": "Description du plan",
    "entity.label.contract_end_date": "Date de fin du contrat",
    "entity.label.ticket_number": "Numéro de ticket",
    "entity.label.priority": "Priorité",
    "entity.label.ticket_date": "Date du ticket",
    "entity.label.problem_code": "Code de problème",
    "entity.label.status": "Statut",
    "entity.label.title": "Titre",
    "entity.label.assign_to": "Assigner à",
    "entity.label.id": "ID",
    "entity.label.transaction_date": "Date de Transaction",
    "entity.label.commission_amount": "Montant de la Commission",
    "entity.label.commission_type": "Type de Commission",
    "entity.label.commission_rate": "Taux de Commission",
    "entity.label.transaction_id": "ID de Transaction",
    "entity.label.transaction_type": "Type de Transaction",
    "entity.label.amount": "Montant",
    "entity.label.category": "Catégorie",
    "entity.label.cancel_remark": "Remarque d'Annulation",
    "entity.label.source": "Source",
    "entity.label.stb_number": "Numéro STB",
    "entity.label.customer_number": "Numéro du client",
    "entity.label.name": "Nom",
    "entity.label.mobile_number": "Numéro de téléphone portable",
    "entity.label.order_number": "Numéro de commande",
    "entity.label.active_date": "Date d'activation",
    "entity.label.expiry_date": "Date d'expiration",
    "entity.label.balance_amount": "Montant du solde",
    "entity.label.roaming_settlement": "Règlement d'itinérance",
    "entity.label.interconnect_settlement": "Règlement d'interconnexion",
    "entity.label.contract_agreement": "Accord de contrat",
    "entity.label.tariff_plan_agreement": "Accord de plan tarifaire",
    "entity.label.new_ticket": "Créer un nouveau ticket",
    "entity.label.priority": "Priorité",
    "entity.label.ticket_date": "Date du ticket",
    "entity.label.sub_category": "Sous-catégorie",
    "entity.label.due_time": "Heure de fin",
    "entity.label.description": "Description",
    "entity.label.save": "Enregistrer",
    "entity.label.receipt_no": "Numéro de reçu",
    "entity.label.payment_date": "Date de paiement",
    "entity.label.create_payments": "Créer des paiements",
    "entity.label.collection_by": "Collection par",
    "entity.label.notes": "Remarques",
    "entity.label.is_wallet": "Est Portefeuille",
    "entity.label.bank_name": "Nom de la Banque",
    "entity.label.branch_name": "Nom de la Succursale",
    "entity.label.create_adjustment": "Créer un Ajustement",
    "entity.label.adjustment_date": "Date de l'Ajustement",
    "entity.label.adjustment_code": "Code de l'Ajustement",
    "entity.label.adjustment_amount": "Montant de l'Ajustement",
    "entity.label.adjustment_type": "Type d'Ajustement",
    "entity.label.view_ticket": "Voir le Ticket",
    "entity.label.close_ticket": "Fermer le Ticket",
    "entity.label.edit_ticket": "Modifier le Ticket",
    "entity.label.last_comment": "Dernier Commentaire",
    "entity.label.problem_description": "Description du Problème",
    "entity.label.comment_date": "Date du Commentaire",
    "entity.label.file": "Fichier",
    "entity.label.agreement": "Accord",
    "entity.label.create_agreement": "Créer un Accord",
    "entity.label.partner_agreement": "Accord Partenaire",
    "entity.label.contract_effect_date": "Date d'Effet du Contrat",
    "entity.label.agreement_date": "Date de l'Accord",
    "entity.label.agreement_status": "Statut de l'Accord",
    "entity.label.agreement_type": "Type d'Accord",
    "entity.label.business_entity": "Entité commerciale",
    "entity.label.business_entity_details": "Détails de l'entité commerciale",
    "entity.label.CancelFinancialTransaction":
      "Annuler la Transaction Financière",
    "entity.label.CancelRemark": "Remarque d'Annulation",
    "entity.label.Save": "Enregistrer",
    "entity.label.Cancel": "Annuler",
    "entity.label.PartnerAgreement": "Accord de Partenariat",
    "entity.label.ContractEffectDate": "Date d'Effet du Contrat",
    "entity.label.AgreementDate": "Date d'Ajustement",
    "entity.label.AgreementStatus": "Statut de l'Accord",
    "entity.label.AgreementType": "Type d'Accord",
    "entity.label.AgreementDetails": "Détails de l'Accord",
    "entity.label.ActivityLog": "Journal d'Activité",
    "entity.label.BusinessEntityId": "ID de l'Entité Commerciale",
    "entity.label.TransactionDate": "Date de la Transaction",
    "entity.label.TransactionType": "Type de Transaction",
    "entity.label.History": "Historique",
    "entity.label.AdjustmentDate": "Date d'Ajustement",
    "entity.label.Commission": "Commission",
    "entity.label.CommissionType": "Type de Commission",
    "entity.label.Value": "Valeur",
    "entity.label.Type": "Type",
    "entity.label.TAPVersion": "Version TAP",
    "entity.label.TAPInSequence": "Séquence Entrante TAP",
    "entity.label.TAPOutSequence": "Séquence Sortante TAP",
    "entity.label.RAPInSequence": "Séquence Entrante RAP",
    "entity.label.RAPOutSequence": "Séquence Sortante RAP",
    "entity.label.NRTRDEInSequence": "Séquence Entrante NRTRDE",
    "entity.label.NRTRDEOutSequence": "Séquence Sortante NRTRDE",
    "entity.label.Configure": "Configurer",
    "entity.label.CancelFinancialTransaction":
      "Annuler la Transaction Financière",
    "entity.label.cancelremark": "Remarque d'Annulation",
    "entity.label.Create_Payment": "Créer un Paiement",
  },

  es: {
    "entity.label.Edit": "Editar",
  "entity.label.UpdateCredit": "Actualizar crédito",
  "entity.label.AddTicket": "Agregar ticket",
  "entity.label.DownloadUploadedFile": "Descargar archivo",
  "entity.label.Close": "Cerrar",
  "entity.label.ReopenTicket": "Reabrir ticket",
  "entity.label.ResolutionDescription": "Descripción de la resolución",
  "entity.label.SelectCategory": "Seleccionar categoría",
  "entity.label.SelectSubCategory": "Seleccionar subcategoría",
  "entity.label.description": "Descripción",
  "entity.label.CloseTicket": "Cerrar ticket",
    "entity.label.Commission": "Comisión",
  "entity.label.CommisionType": "Tipo de comisión",
  "entity.label.Configure": "Configurar",
  "entity.label.Agreement": "Acuerdo",
  "entity.label.Type": "Tipo",
  "entity.label.TAP_version": "Versión TAP",
  "entity.label.TAP_In_sequence": "Secuencia TAP Entrada",
  "entity.label.TAP_Out_sequence": "Secuencia TAP Salida",
  "entity.label.RAP_In_Sequence": "Secuencia RAP Entrada",
  "entity.label.RAP_Out_Sequence": "Secuencia RAP Salida",
  "entity.label.NRTRDE_In_Sequence": "Secuencia NRTRDE Entrada",
  "entity.label.NRTRDE_Out_Sequence": "Secuencia NRTRDE Salida",
  "entity.label.In": "Entrada",
  "entity.label.Plan": "Plan",
  "entity.label.Out": "Salida",
  "entity.label.Cancel": "Cancelar",
  "entity.label.Save": "Guardar",
    "entity.label.SelectSearch": "Seleccionar búsqueda",
  "entity.label.SelectPriority": "Seleccionar prioridad",
  "entity.label.SelectCategory": "Seleccionar categoría",
  "entity.label.SelectSubCategory": "Seleccionar subcategoría",
  "entity.label.SelectSource": "Seleccionar fuente",
    "entity.label.business_entity_transaction_history":
      "Historial de transacciones de entidades comerciales",
    "entity.label.edit_business_entity": "Editar entidad comercial",
    "entity.label.business_entity": "Entidad comercial",
    "entity.label.business_entity_name": "Nombre de la entidad comercial",
    "entity.label.business_entity_code": "Código de entidad comercial",
    "entity.label.parent_business_entity": "Entidad comercial matriz",
    "entity.label.business_entity_type": "Tipo de entidad comercial",
    "entity.label.opened_on": "Abierto en",
    "entity.label.actions": "Accione",
    "entity.label.clear": "Borrar",
    "entity.label.credit": "Crédito",
    "entity.label.create_new_ticket": "Crear nuevo ticket",
    "entity.label.cheque_no": "N° de cheque",
    "entity.label.from_date": "Desde la fecha",
    "entity.label.to_date": "Hasta la fecha",
    "entity.label.filter_by_date": "Filtrar por fecha",
    "entity.label.start_date": "Fecha de inicio",
    "entity.label.end_date": "Fecha de finalización",
    "entity.label.search": "Buscar",
    "entity.label.tree_view": "Vista de árbol",
    "entity.label.activity_log": "Registro de actividad",
    "entity.label.create_business_entity": "Crear entidad comercial",
    "entity.label.business_entity_tree_view":
      "Vista de árbol de entidades comerciales",
    "entity.label.list_view": "Vista de lista",
    "entity.label.business_entity_opened_on": "Entidad comercial abierta el",
    "entity.label.relationship_type": "Tipo de Relación",
    "entity.label.business_entity_info": "Información de la entidad comercial",
    "entity.label.company_info": "Información de la empresa",
    "entity.label.done": "Hecho",
    "entity.label.company_reg_no": "Número de registro de la empresa",
    "entity.label.email": "Correo electrónico",
    "entity.label.payment_type": "Tipo de pago",
    "entity.label.address_name": "Nombre de la dirección",
    "entity.label.segment_type": "Tipo de segmento",
    "entity.label.city_area": "Ciudad/Área",
    "entity.label.contact_person": "Persona de contacto",
    "entity.label.district": "Distrito",
    "entity.label.phone_number": "Número de teléfono",
    "entity.label.state": "Estado",
    "entity.label.pan_card_no": "Número de tarjeta Pan",
    "entity.label.country": "País",
    "entity.label.gst_reg_no": "Número de registro de GST",
    "entity.label.subscriber_dues": "Cuotas de suscriptor",
    "entity.label.zip_code": "Código postal",
    "entity.label.commission_model": "Modelo de comisión",
    "entity.label.successfully_created_business_entity":
      "Entidad comercial creada con éxito",
    "entity.label.successfully_edited_business_entity":
      "Entidad comercial editada correctamente",
    "entity.label.go_back_to_business_entity_list":
      "Volver a la lista de entidades comerciales",
    "entity.label.cancel": "Cancelar",
    "entity.label.previous": "Anterior",
    "entity.label.next": "Siguiente",
    "entity.label.submit": "Enviar",
    "entity.label.view_business_entity": "Ver entidad comercial",
    "entity.label.add_ticket": "Agregar ticket",
    "entity.label.payments": "Pagos",
    "entity.label.adjustments": "Ajustes",
    "entity.label.agreements": "Acuerdos",
    "entity.label.charges": "Cargos",
    "entity.label.basic_information": "Información básica",
    "entity.label.address_information": "Información de dirección",
    "entity.label.balance": "Saldo",
    "entity.label.credit_limit": "Límite de crédito",
    "entity.label.agreement_details": "Detalles del acuerdo",
    "entity.label.tickets": "Tickets",
    "entity.label.business_entity_disbursements":
      "Desembolsos de entidades comerciales",
    "entity.label.financial_transactions": "Transacciones financieras",
    "entity.label.customers": "Clientes",
    "entity.label.settlement": "Liquidación",
    "entity.label.plan_description": "Descripción del plan",
    "entity.label.contract_end_date": "Fecha de finalización del contrato",
    "entity.label.ticket_number": "Número de ticket",
    "entity.label.priority": "Prioridad",
    "entity.label.ticket_date": "Fecha del ticket",
    "entity.label.problem_code": "Código de problema",
    "entity.label.status": "Estado",
    "entity.label.title": "Título",
    "entity.label.assign_to": "Asignar a",
    "entity.label.id": "ID",
    "entity.label.transaction_date": "Fecha de Transacción",
    "entity.label.commission_amount": "Monto de Comisión",
    "entity.label.commission_type": "Tipo de Comisión",
    "entity.label.commission_rate": "Tasa de Comisión",
    "entity.label.transaction_id": "ID de Transacción",
    "entity.label.transaction_type": "Tipo de Transacción",
    "entity.label.amount": "Cantidad",
    "entity.label.category": "Categoría",
    "entity.label.cancel_remark": "Observación de Cancelación",
    "entity.label.source": "Fuente",
    "entity.label.stb_number": "Número de STB",
    "entity.label.customer_number": "Número de Cliente",
    "entity.label.name": "Nombre",
    "entity.label.mobile_number": "Número de Teléfono Móvil",
    "entity.label.order_number": "Número de Orden",
    "entity.label.active_date": "Fecha de Activación",
    "entity.label.expiry_date": "Fecha de Vencimiento",
    "entity.label.balance_amount": "Monto del Saldo",
    "entity.label.roaming_settlement": "Liquidación de Roaming",
    "entity.label.interconnect_settlement": "Liquidación de Interconexión",
    "entity.label.contract_agreement": "Acuerdo de Contrato",
    "entity.label.tariff_plan_agreement": "Acuerdo de Plan Tarifario",
    "entity.label.new_ticket": "Crear Nuevo Ticket",
    "entity.label.priority": "Prioridad",
    "entity.label.ticket_date": "Fecha del Ticket",
    "entity.label.sub_category": "Sub Categoría",
    "entity.label.due_time": "Hora de Vencimiento",
    "entity.label.description": "Descripción",
    "entity.label.save": "Guardar",
    "entity.label.receipt_no": "Número de Recibo",
    "entity.label.payment_date": "Fecha de Pago",
    "entity.label.create_payments": "Crear Pagos",
    "entity.label.collection_by": "Recogido Por",
    "entity.label.notes": "Notas",
    "entity.label.is_wallet": "Es Monedero",
    "entity.label.bank_name": "Nombre del Banco",
    "entity.label.branch_name": "Nombre de la Sucursal",
    "entity.label.create_adjustment": "Crear Ajuste",
    "entity.label.adjustment_date": "Fecha del Ajuste",
    "entity.label.adjustment_code": "Código del Ajuste",
    "entity.label.adjustment_amount": "Cantidad del Ajuste",
    "entity.label.adjustment_type": "Tipo de Ajuste",
    "entity.label.view_ticket": "Ver Ticket",
    "entity.label.close_ticket": "Cerrar Ticket",
    "entity.label.edit_ticket": "Editar Ticket",
    "entity.label.last_comment": "Último Comentario",
    "entity.label.problem_description": "Descripción del Problema",
    "entity.label.comment_date": "Fecha del Comentario",
    "entity.label.file": "Archivo",
    "entity.label.agreement": "Acuerdo",
    "entity.label.create_agreement": "Crear Acuerdo",
    "entity.label.partner_agreement": "Acuerdo de Socio",
    "entity.label.contract_effect_date": "Fecha de Efecto del Contrato",
    "entity.label.agreement_date": "Fecha del Acuerdo",
    "entity.label.agreement_status": "Estado del Acuerdo",
    "entity.label.agreement_type": "Tipo de Acuerdo",
    "entity.label.business_entity": "Entidad comercial",
    "entity.label.business_entity_details": "Detalles de la entidad comercial",
    "entity.label.CancelFinancialTransaction":
      "Cancelar Transacción Financiera",
    "entity.label.CancelRemark": "Comentario de Cancelación",
    "entity.label.Save": "Guardar",
    "entity.label.Cancel": "Cancelar",
    "entity.label.PartnerAgreement": "Acuerdo de Socio",
    "entity.label.ContractEffectDate": "Fecha de Efecto del Contrato",
    "entity.label.AgreementDate": "Fecha de Ajuste",
    "entity.label.AgreementStatus": "Estado del Acuerdo",
    "entity.label.AgreementType": "Tipo de Acuerdo",
    "entity.label.AgreementDetails": "Detalles del Acuerdo",
    "entity.label.ActivityLog": "Registro de Actividades",
    "entity.label.BusinessEntityId": "ID de Entidad Comercial",
    "entity.label.TransactionDate": "Fecha de la Transacción",
    "entity.label.TransactionType": "Tipo de Transacción",
    "entity.label.History": "Historial",
    "entity.label.AdjustmentDate": "Fecha de Ajuste",
    "entity.label.Commission": "Comisión",
    "entity.label.CommissionType": "Tipo de Comisión",
    "entity.label.Value": "Valor",
    "entity.label.Type": "Tipo",
    "entity.label.TAPVersion": "Versión TAP",
    "entity.label.TAPInSequence": "Secuencia de Entrada TAP",
    "entity.label.TAPOutSequence": "Secuencia de Salida TAP",
    "entity.label.RAPInSequence": "Secuencia de Entrada RAP",
    "entity.label.RAPOutSequence": "Secuencia de Salida RAP",
    "entity.label.NRTRDEInSequence": "Secuencia de Entrada NRTRDE",
    "entity.label.NRTRDEOutSequence": "Secuencia de Salida NRTRDE",
    "entity.label.Configure": "Configurar",
    "entity.label.CancelFinancialTransaction":
      "Cancelar la Transacción Financiera",
    "entity.label.cancelremark": "Comentario de Cancelación",
    "entity.label.Create_Payment": "Crear Pago",
  },

  pt: {
    "entity.label.Edit": "Editar",
  "entity.label.UpdateCredit": "Atualizar crédito",
  "entity.label.AddTicket": "Adicionar ticket",
  "entity.label.DownloadUploadedFile": "Baixar arquivo",
  "entity.label.Close": "Fechar",
  "entity.label.ReopenTicket": "Reabrir ticket",
  "entity.label.ResolutionDescription": "Descrição da resolução",
  "entity.label.SelectCategory": "Selecionar categoria",
  "entity.label.SelectSubCategory": "Selecionar subcategoria",
  "entity.label.description": "Descrição",
  "entity.label.CloseTicket": "Fechar ticket",
    "entity.label.Commission": "Comissão",
  "entity.label.CommisionType": "Tipo de comissão",
  "entity.label.Configure": "Configurar",
  "entity.label.Agreement": "Acordo",
  "entity.label.Type": "Tipo",
  "entity.label.TAP_version": "Versão TAP",
  "entity.label.TAP_In_sequence": "Sequência TAP Entrada",
  "entity.label.TAP_Out_sequence": "Sequência TAP Saída",
  "entity.label.RAP_In_Sequence": "Sequência RAP Entrada",
  "entity.label.RAP_Out_Sequence": "Sequência RAP Saída",
  "entity.label.NRTRDE_In_Sequence": "Sequência NRTRDE Entrada",
  "entity.label.NRTRDE_Out_Sequence": "Sequência NRTRDE Saída",
  "entity.label.In": "Entrada",
  "entity.label.Plan": "Plano",
  "entity.label.Out": "Saída",
  "entity.label.Cancel": "Cancelar",
  "entity.label.Save": "Salvar",
    "entity.label.SelectSearch": "Selecionar pesquisa",
  "entity.label.SelectPriority": "Selecionar prioridade",
  "entity.label.SelectCategory": "Selecionar categoria",
  "entity.label.SelectSubCategory": "Selecionar subcategoria",
  "entity.label.SelectSource": "Selecionar fonte",
    "entity.label.business_entity_transaction_history":
      "Histórico de transações de entidades comerciais",
    "entity.label.edit_business_entity": "Editar entidade comercial",
    "entity.label.business_entity": "Entidade comercial",
    "entity.label.business_entity_name": "Nome da entidade comercial",
    "entity.label.business_entity_code": "Código da entidade comercial",
    "entity.label.parent_business_entity": "Entidade Empresarial Matriz",
    "entity.label.business_entity_type": "Tipo de entidade empresarial",
    "entity.label.opened_on": "Aberto em",
    "entity.label.actions": "Açõe",
    "entity.label.clear": "Limpar",
    "entity.label.credit": "Crédito",
    "entity.label.create_new_ticket": "Criar novo ticket",
    "entity.label.cheque_no": "Nº do cheque",
    "entity.label.from_date": "Data de início",
    "entity.label.to_date": "Data de término",
    "entity.label.filter_by_date": "Filtrar por data",
    "entity.label.start_date": "Data de início",
    "entity.label.end_date": "Data de término",
    "entity.label.search": "Buscar",
    "entity.label.tree_view": "Visualização em árvore",
    "entity.label.activity_log": "Registro de atividade",
    "entity.label.create_business_entity": "Criar entidade comercial",
    "entity.label.business_entity_tree_view":
      "Visualização em árvore da entidade comercial",
    "entity.label.list_view": "Visualização em lista",
    "entity.label.business_entity_opened_on": "Entidade comercial aberta em",
    "entity.label.relationship_type": "Tipo de Relacionamento",
    "entity.label.business_entity_info": "Informações da entidade comercial",
    "entity.label.company_info": "Informações da empresa",
    "entity.label.done": "Concluído",
    "entity.label.company_reg_no": "Número de registro da empresa",
    "entity.label.email": "Email",
    "entity.label.payment_type": "Tipo de pagamento",
    "entity.label.address_name": "Nome do endereço",
    "entity.label.segment_type": "Tipo de segmento",
    "entity.label.city_area": "Cidade/Área",
    "entity.label.contact_person": "Pessoa de contato",
    "entity.label.district": "Distrito",
    "entity.label.phone_number": "Número de telefone",
    "entity.label.state": "Estado",
    "entity.label.pan_card_no": "Número do PAN Card",
    "entity.label.country": "País",
    "entity.label.gst_reg_no": "Número de Registro do GST",
    "entity.label.subscriber_dues": "Dívidas do Assinante",
    "entity.label.zip_code": "Código Postal",
    "entity.label.commission_model": "Modelo de Comissão",
    "entity.label.successfully_created_business_entity":
      "Entidade comercial criada com sucesso",
    "entity.label.successfully_edited_business_entity":
      "Entidade comercial editada com sucesso",
    "entity.label.go_back_to_business_entity_list":
      "Voltar para a lista de entidades comerciais",
    "entity.label.cancel": "Cancelar",
    "entity.label.previous": "Anterior",
    "entity.label.next": "Próximo",
    "entity.label.submit": "Enviar",
    "entity.label.view_business_entity": "Ver entidade comercial",
    "entity.label.add_ticket": "Adicionar Ticket",
    "entity.label.payments": "Pagamentos",
    "entity.label.adjustments": "Ajustes",
    "entity.label.agreements": "Acordos",
    "entity.label.charges": "Taxas",
    "entity.label.basic_information": "Informações Básicas",
    "entity.label.address_information": "Informações de Endereço",
    "entity.label.balance": "Saldo",
    "entity.label.credit_limit": "Limite de Crédito",
    "entity.label.agreement_details": "Detalhes do Acordo",
    "entity.label.tickets": "Tickets",
    "entity.label.business_entity_disbursements":
      "Desembolsos de entidades empresariais",
    "entity.label.financial_transactions": "Transações Financeiras",
    "entity.label.customers": "Clientes",
    "entity.label.settlement": "Pagamento",
    "entity.label.plan_description": "Descrição do Plano",
    "entity.label.contract_end_date": "Data de Término do Contrato",
    "entity.label.ticket_number": "Número do Ticket",
    "entity.label.priority": "Prioridade",
    "entity.label.ticket_date": "Data do Ticket",
    "entity.label.problem_code": "Código do Problema",
    "entity.label.status": "Status",
    "entity.label.title": "Título",
    "entity.label.assign_to": "Atribuir a",
    "entity.label.id": "ID",
    "entity.label.transaction_date": "Data da Transação",
    "entity.label.commission_amount": "Valor da Comissão",
    "entity.label.commission_type": "Tipo de Comissão",
    "entity.label.commission_rate": "Taxa de Comissão",
    "entity.label.transaction_id": "ID da Transação",
    "entity.label.transaction_type": "Tipo de Transação",
    "entity.label.amount": "Valor",
    "entity.label.category": "Categoria",
    "entity.label.cancel_remark": "Observação de Cancelamento",
    "entity.label.source": "Origem",
    "entity.label.stb_number": "Número do STB",
    "entity.label.customer_number": "Número do Cliente",
    "entity.label.name": "Nome",
    "entity.label.mobile_number": "Número de Telemóvel",
    "entity.label.order_number": "Número do Pedido",
    "entity.label.active_date": "Data de Ativação",
    "entity.label.expiry_date": "Data de Expiração",
    "entity.label.balance_amount": "Valor do Saldo",
    "entity.label.roaming_settlement": "Acordo de Roaming",
    "entity.label.interconnect_settlement": "Acordo de Interconexão",
    "entity.label.contract_agreement": "Acordo Contratual",
    "entity.label.tariff_plan_agreement": "Acordo de Plano Tarifário",
    "entity.label.new_ticket": "Criar Novo Ticket",
    "entity.label.priority": "Prioridade",
    "entity.label.ticket_date": "Data do Ticket",
    "entity.label.sub_category": "Subcategoria",
    "entity.label.due_time": "Hora de Vencimento",
    "entity.label.description": "Descrição",
    "entity.label.save": "Salvar",
    "entity.label.receipt_no": "Número do Recibo",
    "entity.label.payment_date": "Data de Pagamento",
    "entity.label.create_payments": "Criar Pagamentos",
    "entity.label.collection_by": "Coletado Por",
    "entity.label.notes": "Notas",
    "entity.label.is_wallet": "É Carteira",
    "entity.label.bank_name": "Nome do Banco",
    "entity.label.branch_name": "Nome da Agência",
    "entity.label.create_adjustment": "Criar Ajuste",
    "entity.label.adjustment_date": "Data do Ajuste",
    "entity.label.adjustment_code": "Código do Ajuste",
    "entity.label.adjustment_amount": "Valor do Ajuste",
    "entity.label.adjustment_type": "Tipo de Ajuste",
    "entity.label.view_ticket": "Ver Ticket",
    "entity.label.close_ticket": "Fechar Ticket",
    "entity.label.edit_ticket": "Editar Ticket",
    "entity.label.last_comment": "Último Comentário",
    "entity.label.problem_description": "Descrição do Problema",
    "entity.label.comment_date": "Data do Comentário",
    "entity.label.file": "Arquivo",
    "entity.label.agreement": "Acordo",
    "entity.label.create_agreement": "Criar Acordo",
    "entity.label.partner_agreement": "Acordo de Parceiro",
    "entity.label.contract_effect_date": "Data de Efeito do Contrato",
    "entity.label.agreement_date": "Data do Acordo",
    "entity.label.agreement_status": "Estado do Acordo",
    "entity.label.agreement_type": "Tipo de Acordo",
    "entity.label.business_entity": "Entidade comercial",
    "entity.label.business_entity_details": "Detalhes da entidade comercial",
    "entity.label.CancelFinancialTransaction": "Cancelar Transação Financeira",
    "entity.label.CancelRemark": "Observação de Cancelamento",
    "entity.label.Save": "Salvar",
    "entity.label.Cancel": "Cancelar",
    "entity.label.PartnerAgreement": "Acordo de Parceiro",
    "entity.label.ContractEffectDate": "Data de Efeito do Contrato",
    "entity.label.AgreementDate": "Data de Ajuste",
    "entity.label.AgreementStatus": "Status do Acordo",
    "entity.label.AgreementType": "Tipo de Acordo",
    "entity.label.AgreementDetails": "Detalhes do Acordo",
    "entity.label.ActivityLog": "Registro de Atividades",
    "entity.label.BusinessEntityId": "ID da Entidade Comercial",
    "entity.label.TransactionDate": "Data da Transação",
    "entity.label.TransactionType": "Tipo de Transação",
    "entity.label.History": "Histórico",
    "entity.label.AdjustmentDate": "Data de Ajuste",
    "entity.label.Commission": "Comissão",
    "entity.label.CommissionType": "Tipo de Comissão",
    "entity.label.Value": "Valor",
    "entity.label.Type": "Tipo",
    "entity.label.TAPVersion": "Versão TAP",
    "entity.label.TAPInSequence": "Sequência de Entrada TAP",
    "entity.label.TAPOutSequence": "Sequência de Saída TAP",
    "entity.label.RAPInSequence": "Sequência de Entrada RAP",
    "entity.label.RAPOutSequence": "Sequência de Saída RAP",
    "entity.label.NRTRDEInSequence": "Sequência de Entrada NRTRDE",
    "entity.label.NRTRDEOutSequence": "Sequência de Saída NRTRDE",
    "entity.label.Configure": "Configurar",
    "entity.label.CancelFinancialTransaction": "Cancelar Transação Financeira",
    "entity.label.cancelremark": "Observação de Cancelamento",
    "entity.label.Create_Payment": "Criar Pagamento",
  },

  zh_CN: {
    "entity.label.Edit": "编辑",
  "entity.label.UpdateCredit": "更新信用",
  "entity.label.AddTicket": "添加工单",
  "entity.label.DownloadUploadedFile": "下载已上传文件",
  "entity.label.Close": "关闭",
  "entity.label.ReopenTicket": "重新打开工单",
  "entity.label.ResolutionDescription": "解决方案描述",
  "entity.label.SelectCategory": "选择类别",
  "entity.label.SelectSubCategory": "选择子类别",
  "entity.label.description": "描述",
  "entity.label.CloseTicket": "关闭工单",
    "entity.label.Commission": "佣金",
  "entity.label.CommisionType": "佣金类型",
  "entity.label.Configure": "配置",
  "entity.label.Agreement": "协议",
  "entity.label.Type": "类型",
  "entity.label.TAP_version": "TAP版本",
  "entity.label.TAP_In_sequence": "TAP输入顺序",
  "entity.label.TAP_Out_sequence": "TAP输出顺序",
  "entity.label.RAP_In_Sequence": "RAP输入顺序",
  "entity.label.RAP_Out_Sequence": "RAP输出顺序",
  "entity.label.NRTRDE_In_Sequence": "NRTRDE输入顺序",
  "entity.label.NRTRDE_Out_Sequence": "NRTRDE输出顺序",
  "entity.label.In": "输入",
  "entity.label.Plan": "计划",
  "entity.label.Out": "输出",
  "entity.label.Cancel": "取消",
  "entity.label.Save": "保存",
    "entity.label.SelectSearch": "选择搜索",
  "entity.label.SelectPriority": "选择优先级",
  "entity.label.SelectCategory": "选择类别",
  "entity.label.SelectSubCategory": "选择子类别",
  "entity.label.SelectSource": "选择来源",
    "entity.label.business_entity_transaction_history": "商業實體交易歷史",
    "entity.label.edit_business_entity": "編輯商業實體",
    "entity.label.business_entity": "商业实体",
    "entity.label.business_entity_name": "商業實體名稱",
    "entity.label.business_entity_code": "商業實體程式碼",
    "entity.label.parent_business_entity": "母公司企業實體",
    "entity.label.business_entity_type": "商業實體類型",
    "entity.label.opened_on": "开启时间",
    "entity.label.actions": "操作",
    "entity.label.clear": "清除",
    "entity.label.credit": "信用",
    "entity.label.create_new_ticket": "创建新工单",
    "entity.label.cheque_no": "支票号码",
    "entity.label.from_date": "起始日期",
    "entity.label.to_date": "结束日期",
    "entity.label.filter_by_date": "按日期筛选",
    "entity.label.start_date": "开始日期",
    "entity.label.end_date": "结束日期",
    "entity.label.search": "搜索",
    "entity.label.tree_view": "树形视图",
    "entity.label.activity_log": "活动日志",
    "entity.label.create_business_entity": "建立商業實體",
    "entity.label.business_entity_tree_view": "業務實體樹視圖",
    "entity.label.list_view": "列表视图",
    "entity.label.business_entity_opened_on": "商業實體開業於",
    "entity.label.relationship_type": "关系类型",
    "entity.label.business_entity_info": "企業實體資訊",
    "entity.label.company_info": "公司信息",
    "entity.label.done": "完成",
    "entity.label.company_reg_no": "公司注册号",
    "entity.label.email": "电子邮件",
    "entity.label.payment_type": "支付类型",
    "entity.label.address_name": "地址名称",
    "entity.label.segment_type": "分段类型",
    "entity.label.city_area": "城市/地区",
    "entity.label.contact_person": "联系人",
    "entity.label.district": "区/县",
    "entity.label.phone_number": "电话号码",
    "entity.label.state": "州/省",
    "entity.label.pan_card_no": "Pancard 号码",
    "entity.label.country": "国家",
    "entity.label.gst_reg_no": "GST 注册号",
    "entity.label.subscriber_dues": "订户欠款",
    "entity.label.zip_code": "邮政编码",
    "entity.label.commission_model": "佣金模式",
    "entity.label.successfully_created_business_entity": "成功創建商業實體",
    "entity.label.successfully_edited_business_entity": "已成功編輯企業實體",
    "entity.label.go_back_to_business_entity_list": "傳回企業實體列表",
    "entity.label.cancel": "取消",
    "entity.label.previous": "上一页",
    "entity.label.next": "下一页",
    "entity.label.submit": "提交",
    "entity.label.view_business_entity": "查看商業實體",
    "entity.label.add_ticket": "添加工单",
    "entity.label.payments": "支付",
    "entity.label.adjustments": "调整",
    "entity.label.agreements": "协议",
    "entity.label.charges": "费用",
    "entity.label.basic_information": "基本信息",
    "entity.label.address_information": "地址信息",
    "entity.label.balance": "余额",
    "entity.label.credit_limit": "信用额度",
    "entity.label.agreement_details": "协议详情",
    "entity.label.tickets": "工单",
    "entity.label.business_entity_disbursements": "商業實體支出",
    "entity.label.financial_transactions": "财务交易",
    "entity.label.customers": "客户",
    "entity.label.settlement": "结算",
    "entity.label.plan_description": "计划描述",
    "entity.label.contract_end_date": "合同结束日期",
    "entity.label.ticket_number": "工单编号",
    "entity.label.priority": "优先级",
    "entity.label.ticket_date": "工单日期",
    "entity.label.problem_code": "问题代码",
    "entity.label.status": "状态",
    "entity.label.title": "标题",
    "entity.label.assign_to": "分配给",
    "entity.label.id": "ID",
    "entity.label.transaction_date": "交易日期",
    "entity.label.commission_amount": "佣金金额",
    "entity.label.commission_type": "佣金类型",
    "entity.label.commission_rate": "佣金率",
    "entity.label.transaction_id": "交易ID",
    "entity.label.transaction_type": "交易类型",
    "entity.label.amount": "金额",
    "entity.label.category": "类别",
    "entity.label.cancel_remark": "取消备注",
    "entity.label.source": "来源",
    "entity.label.stb_number": "机顶盒编号",
    "entity.label.customer_number": "客户编号",
    "entity.label.name": "姓名",
    "entity.label.mobile_number": "手机号码",
    "entity.label.order_number": "订单编号",
    "entity.label.active_date": "激活日期",
    "entity.label.expiry_date": "到期日期",
    "entity.label.balance_amount": "余额金额",
    "entity.label.roaming_settlement": "漫游结算",
    "entity.label.interconnect_settlement": "互联结算",
    "entity.label.contract_agreement": "合同协议",
    "entity.label.tariff_plan_agreement": "资费计划协议",
    "entity.label.new_ticket": "创建新工单",
    "entity.label.priority": "优先级",
    "entity.label.ticket_date": "工单日期",
    "entity.label.sub_category": "子类别",
    "entity.label.due_time": "到期时间",
    "entity.label.description": "描述",
    "entity.label.save": "保存",
    "entity.label.receipt_no": "收据编号",
    "entity.label.payment_date": "付款日期",
    "entity.label.create_payments": "创建付款",
    "entity.label.collection_by": "收款人",
    "entity.label.notes": "备注",
    "entity.label.is_wallet": "是钱包",
    "entity.label.bank_name": "银行名称",
    "entity.label.branch_name": "分行名称",
    "entity.label.create_adjustment": "创建调整",
    "entity.label.adjustment_date": "调整日期",
    "entity.label.adjustment_code": "调整代码",
    "entity.label.adjustment_amount": "调整金额",
    "entity.label.adjustment_type": "调整类型",
    "entity.label.view_ticket": "查看工单",
    "entity.label.close_ticket": "关闭工单",
    "entity.label.edit_ticket": "编辑工单",
    "entity.label.last_comment": "最后评论",
    "entity.label.problem_description": "问题描述",
    "entity.label.comment_date": "评论日期",
    "entity.label.file": "文件",
    "entity.label.agreement": "协议",
    "entity.label.create_agreement": "创建协议",
    "entity.label.partner_agreement": "合作伙伴协议",
    "entity.label.contract_effect_date": "合同生效日期",
    "entity.label.agreement_date": "协议日期",
    "entity.label.agreement_status": "协议状态",
    "entity.label.agreement_type": "协议类型",
    "entity.label.business_entity": "业务实体",
    "entity.label.business_entity_details": "业务实体详情",
    "entity.label.CancelFinancialTransaction": "取消财务交易",
    "entity.label.CancelRemark": "取消备注",
    "entity.label.Save": "保存",
    "entity.label.Cancel": "取消",
    "entity.label.PartnerAgreement": "合作伙伴协议",
    "entity.label.ContractEffectDate": "合同生效日期",
    "entity.label.AgreementDate": "调整日期",
    "entity.label.AgreementStatus": "协议状态",
    "entity.label.AgreementType": "协议类型",
    "entity.label.AgreementDetails": "协议详情",
    "entity.label.ActivityLog": "活动日志",
    "entity.label.BusinessEntityId": "业务实体ID",
    "entity.label.TransactionDate": "交易日期",
    "entity.label.TransactionType": "交易类型",
    "entity.label.History": "历史",
    "entity.label.AdjustmentDate": "调整日期",
    "entity.label.Commission": "佣金",
    "entity.label.CommissionType": "佣金类型",
    "entity.label.Value": "值",
    "entity.label.Type": "类型",
    "entity.label.TAPVersion": "TAP版本",
    "entity.label.TAPInSequence": "TAP入序列",
    "entity.label.TAPOutSequence": "TAP出序列",
    "entity.label.RAPInSequence": "RAP入序列",
    "entity.label.RAPOutSequence": "RAP出序列",
    "entity.label.NRTRDEInSequence": "NRTRDE入序列",
    "entity.label.NRTRDEOutSequence": "NRTRDE出序列",
    "entity.label.Configure": "配置",
    "entity.label.CancelFinancialTransaction": "取消财务交易",
    "entity.label.cancelremark": "取消备注",
    "entity.label.Create_Payment": "创建付款",
  },
  hi: {
    "entity.label.Edit": "संपादित करें",
  "entity.label.UpdateCredit": "क्रेडिट अपडेट करें",
  "entity.label.AddTicket": "टिकट जोड़ें",
  "entity.label.DownloadUploadedFile": "अपलोड की गई फ़ाइल डाउनलोड करें",
  "entity.label.Close": "बंद करें",
  "entity.label.ReopenTicket": "टिकट फिर से खोलें",
  "entity.label.ResolutionDescription": "समाधान विवरण",
  "entity.label.SelectCategory": "श्रेणी चुनें",
  "entity.label.SelectSubCategory": "उपश्रेणी चुनें",
  "entity.label.description": "विवरण",
  "entity.label.CloseTicket": "टिकट बंद करें",
    "entity.label.Commission": "कमीशन",
  "entity.label.CommisionType": "कमीशन प्रकार",
  "entity.label.Configure": "कॉन्फ़िगर करें",
  "entity.label.Agreement": "समझौता",
  "entity.label.Type": "प्रकार",
  "entity.label.TAP_version": "TAP संस्करण",
  "entity.label.TAP_In_sequence": "TAP इन अनुक्रम",
  "entity.label.TAP_Out_sequence": "TAP आउट अनुक्रम",
  "entity.label.RAP_In_Sequence": "RAP इन अनुक्रम",
  "entity.label.RAP_Out_Sequence": "RAP आउट अनुक्रम",
  "entity.label.NRTRDE_In_Sequence": "NRTRDE इन अनुक्रम",
  "entity.label.NRTRDE_Out_Sequence": "NRTRDE आउट अनुक्रम",
  "entity.label.In": "इन",
  "entity.label.Plan": "योजना",
  "entity.label.Out": "आउट",
  "entity.label.Cancel": "रद्द करें",
  "entity.label.Save": "सहेजें",
    "entity.label.SelectSearch": "खोज चुनें",
  "entity.label.SelectPriority": "प्राथमिकता चुनें",
  "entity.label.SelectCategory": "श्रेणी चुनें",
  "entity.label.SelectSubCategory": "उपश्रेणी चुनें",
  "entity.label.SelectSource": "स्रोत चुनें",
    "entity.label.business_entity_transaction_history":
      "व्यवसाय इकाई लेनदेन इतिहास",
    "entity.label.edit_business_entity": "व्यावसायिक इकाई संपादित करें",
    "entity.label.business_entity": "व्यावसायिक एंटिटी",
    "entity.label.business_entity_name": "व्यवसाय इकाई का नाम",
    "entity.label.business_entity_code": "व्यवसाय इकाई कोड",
    "entity.label.parent_business_entity": "मूल व्यवसाय इकाई",
    "entity.label.business_entity_type": "व्यावसायिक इकाई प्रकार",
    "entity.label.opened_on": "खुला है",
    "entity.label.actions": "क्रियाएँ",
    "entity.label.clear": "साफ करें",
    "entity.label.credit": "क्रेडिट",
    "entity.label.create_new_ticket": "नया टिकट बनाएँ",
    "entity.label.cheque_no": "चेक संख्या",
    "entity.label.from_date": "आरंभ तिथि",
    "entity.label.to_date": "समाप्ति तिथि",
    "entity.label.filter_by_date": "तिथि के अनुसार छानें",
    "entity.label.start_date": "प्रारंभ तिथि",
    "entity.label.end_date": "अंत तिथि",
    "entity.label.search": "खोजें",
    "entity.label.tree_view": "वृक्ष दृश्य",
    "entity.label.activity_log": "गतिविधि लॉग",
    "entity.label.create_business_entity": "बिजनेस एंटिटी बनाएं",
    "entity.label.business_entity_tree_view": "बिजनेस एंटिटी ट्री व्यू",
    "entity.label.list_view": "सूची दृश्य",
    "entity.label.business_entity_opened_on": "व्यावसायिक इकाई खोली गई",
    "entity.label.relationship_type": "रिश्ते का प्रकार",
    "entity.label.business_entity_info": "व्यवसाय इकाई की जानकारी",
    "entity.label.company_info": "कंपनी की जानकारी",
    "entity.label.done": "किया हुआ",
    "entity.label.company_reg_no": "कंपनी पंजीकरण संख्या",
    "entity.label.email": "ईमेल",
    "entity.label.payment_type": "भुगतान का प्रकार",
    "entity.label.address_name": "पता का नाम",
    "entity.label.segment_type": "खंड प्रकार",
    "entity.label.city_area": "शहर/क्षेत्र",
    "entity.label.contact_person": "संपर्क व्यक्ति",
    "entity.label.district": "जिला",
    "entity.label.phone_number": "फ़ोन नंबर",
    "entity.label.state": "राज्य",
    "entity.label.pan_card_no": "पैनकार्ड नंबर",
    "entity.label.country": "देश",
    "entity.label.gst_reg_no": "जीएसटी पंजीकरण संख्या",
    "entity.label.subscriber_dues": "सब्सक्राइबर देयता",
    "entity.label.zip_code": "पिन कोड",
    "entity.label.commission_model": "कमीशन मॉडल",
    "entity.label.successfully_created_business_entity":
      "सफलतापूर्वक व्यावसायिक इकाई बनाई गई",
    "entity.label.successfully_edited_business_entity":
      "व्यावसायिक इकाई का सफलतापूर्वक संपादन किया गया",
    "entity.label.go_back_to_business_entity_list":
      "व्यवसाय इकाई सूची पर वापस जाएँ",
    "entity.label.cancel": "रद्द करें",
    "entity.label.previous": "पिछला",
    "entity.label.next": "अगला",
    "entity.label.submit": "प्रस्तुत",
    "entity.label.view_business_entity": "व्यावसायिक इकाई देखें",
    "entity.label.add_ticket": "टिकट जोड़ें",
    "entity.label.payments": "भुगतान",
    "entity.label.adjustments": "समायोजन",
    "entity.label.agreements": "अनुबंध",
    "entity.label.charges": "शुल्क",
    "entity.label.basic_information": "मूल जानकारी",
    "entity.label.address_information": "पता जानकारी",
    "entity.label.balance": "संतुलन",
    "entity.label.credit_limit": "क्रेडिट सीमा",
    "entity.label.agreement_details": "समझौते का विवरण",
    "entity.label.tickets": "टिकट",
    "entity.label.business_entity_disbursements": "व्यावसायिक इकाई संवितरण",
    "entity.label.financial_transactions": "वित्तीय लेन-देन",
    "entity.label.customers": "ग्राहक",
    "entity.label.settlement": "समाधान",
    "entity.label.plan_description": "योजना विवरण",
    "entity.label.contract_end_date": "संविदा समाप्ति तिथि",
    "entity.label.ticket_number": "टिकट संख्या",
    "entity.label.priority": "प्राथमिकता",
    "entity.label.ticket_date": "टिकट की तारीख",
    "entity.label.problem_code": "समस्या कोड",
    "entity.label.status": "स्थिति",
    "entity.label.title": "शीर्षक",
    "entity.label.assign_to": "सौंपें",
    "entity.label.id": "आईडी",
    "entity.label.transaction_date": "लेन-देन की तारीख",
    "entity.label.commission_amount": "कमीशन राशि",
    "entity.label.commission_type": "कमीशन प्रकार",
    "entity.label.commission_rate": "कमीशन दर",
    "entity.label.transaction_id": "लेन-देन आईडी",
    "entity.label.transaction_type": "लेन-देन प्रकार",
    "entity.label.amount": "राशि",
    "entity.label.category": "श्रेणी",
    "entity.label.cancel_remark": "रद्द की टिप्पणी",
    "entity.label.source": "स्रोत",
    "entity.label.stb_number": "एसटीबी नंबर",
    "entity.label.customer_number": "ग्राहक संख्या",
    "entity.label.name": "नाम",
    "entity.label.mobile_number": "मोबाइल नंबर",
    "entity.label.order_number": "आदेश संख्या",
    "entity.label.active_date": "सक्रिय तिथि",
    "entity.label.expiry_date": "समाप्ति तिथि",
    "entity.label.balance_amount": "शेष राशि",
    "entity.label.roaming_settlement": "रोमिंग समाधान",
    "entity.label.interconnect_settlement": "इंटरकनेक्ट समाधान",
    "entity.label.contract_agreement": "अनुबंध समझौता",
    "entity.label.tariff_plan_agreement": "टैरिफ प्लान समझौता",
    "entity.label.new_ticket": "नया टिकट बनाएं",
    "entity.label.priority": "प्राथमिकता",
    "entity.label.ticket_date": "टिकट की तारीख",
    "entity.label.sub_category": "उप वर्ग",
    "entity.label.due_time": "समय समाप्त होने का समय",
    "entity.label.description": "विवरण",
    "entity.label.save": "सहेजें",
    "entity.label.receipt_no": "रसीद संख्या",
    "entity.label.payment_date": "भुगतान की तारीख",
    "entity.label.create_payments": "भुगतान बनाएं",
    "entity.label.collection_by": "संग्रह करने वाला",
    "entity.label.notes": "टिप्पणियाँ",
    "entity.label.is_wallet": "क्या वॉलेट है",
    "entity.label.bank_name": "बैंक का नाम",
    "entity.label.branch_name": "शाखा का नाम",
    "entity.label.create_adjustment": "समायोजन बनाएं",
    "entity.label.adjustment_date": "समायोजन की तारीख",
    "entity.label.adjustment_code": "समायोजन कोड",
    "entity.label.adjustment_amount": "समायोजन राशि",
    "entity.label.adjustment_type": "समायोजन प्रकार",
    "entity.label.view_ticket": "टिकट देखें",
    "entity.label.close_ticket": "टिकट बंद करें",
    "entity.label.edit_ticket": "टिकट संपादित करें",
    "entity.label.last_comment": "अंतिम टिप्पणी",
    "entity.label.problem_description": "समस्या का विवरण",
    "entity.label.comment_date": "टिप्पणी की तारीख",
    "entity.label.file": "फ़ाइल",
    "entity.label.agreement": "अनुबंध",
    "entity.label.create_agreement": "अनुबंध बनाएं",
    "entity.label.partner_agreement": "साथी अनुबंध",
    "entity.label.contract_effect_date": "अनुबंध प्रभाव की तारीख",
    "entity.label.agreement_date": "समझौते की तारीख",
    "entity.label.agreement_status": "अनुबंध की स्थिति",
    "entity.label.agreement_type": "अनुबंध के प्रकार",
    "entity.label.business_entity": "व्यापारिक एकाई",
    "entity.label.business_entity_details": "व्यापारिक एकाई विवरण",
    "entity.label.CancelFinancialTransaction": "वित्तीय लेन-देन रद्द करें",
    "entity.label.CancelRemark": "रद्द टिप्पणी",
    "entity.label.Save": "सहेजें",
    "entity.label.Cancel": "रद्द करें",
    "entity.label.PartnerAgreement": "साझेदार समझौता",
    "entity.label.ContractEffectDate": "अनुबंध प्रभाव तिथि",
    "entity.label.AgreementDate": "समायोजन तिथि",
    "entity.label.AgreementStatus": "समझौता स्थिति",
    "entity.label.AgreementType": "समझौता प्रकार",
    "entity.label.AgreementDetails": "समझौता विवरण",
    "entity.label.ActivityLog": "गतिविधि लॉग",
    "entity.label.BusinessEntityId": "व्यावसायिक इकाई आईडी",
    "entity.label.TransactionDate": "लेन-देन की तारीख",
    "entity.label.TransactionType": "लेन-देन का प्रकार",
    "entity.label.History": "इतिहास",
    "entity.label.AdjustmentDate": "समायोजन तिथि",
    "entity.label.Commission": "कमीशन",
    "entity.label.CommissionType": "कमीशन प्रकार",
    "entity.label.Value": "मूल्य",
    "entity.label.Type": "प्रकार",
    "entity.label.TAPVersion": "TAP संस्करण",
    "entity.label.TAPInSequence": "TAP इन सीक्वेंस",
    "entity.label.TAPOutSequence": "TAP आउट सीक्वेंस",
    "entity.label.RAPInSequence": "RAP इन सीक्वेंस",
    "entity.label.RAPOutSequence": "RAP आउट सीक्वेंस",
    "entity.label.NRTRDEInSequence": "NRTRDE इन सीक्वेंस",
    "entity.label.NRTRDEOutSequence": "NRTRDE आउट सीक्वेंस",
    "entity.label.Configure": "कॉन्फ़िगर करें",
    "entity.label.CancelFinancialTransaction": "वित्तीय लेनदेन रद्द करें",
    "entity.label.cancelremark": "रद्द करने की टिप्पणी",
    "entity.label.Create_Payment": "भुगतान बनाएँ",
  },

  ka: {
    "entity.label.Edit": "რედაქტირება",
  "entity.label.UpdateCredit": "კრედიტის განახლება",
  "entity.label.AddTicket": "ბილეთის დამატება",
  "entity.label.DownloadUploadedFile": "ატვირთული ფაილის გადმოწერა",
  "entity.label.Close": "დახურვა",
  "entity.label.ReopenTicket": "ბილეთის ხელახლა გახსნა",
  "entity.label.ResolutionDescription": "გადაწყვეტილების აღწერა",
  "entity.label.SelectCategory": "აირჩიეთ კატეგორია",
  "entity.label.SelectSubCategory": "აირჩიეთ ქვეკატეგორია",
  "entity.label.description": "აღწერა",
  "entity.label.CloseTicket": "ბილეთის დახურვა",
    "entity.label.Commission": "კომისია",
  "entity.label.CommisionType": "კომისიის ტიპი",
  "entity.label.Configure": "კონფიგურაცია",
  "entity.label.Agreement": "შეთანხმება",
  "entity.label.Type": "ტიპი",
  "entity.label.TAP_version": "TAP ვერსია",
  "entity.label.TAP_In_sequence": "TAP შესვლის მიმდევრობა",
  "entity.label.TAP_Out_sequence": "TAP გასვლის მიმდევრობა",
  "entity.label.RAP_In_Sequence": "RAP შესვლის მიმდევრობა",
  "entity.label.RAP_Out_Sequence": "RAP გასვლის მიმდევრობა",
  "entity.label.NRTRDE_In_Sequence": "NRTRDE შესვლის მიმდევრობა",
  "entity.label.NRTRDE_Out_Sequence": "NRTRDE გასვლის მიმდევრობა",
  "entity.label.In": "შესვლა",
  "entity.label.Plan": "გეგმა",
  "entity.label.Out": "გამოსვლა",
  "entity.label.Cancel": "გაუქმება",
  "entity.label.Save": "შენახვა",
    "entity.label.SelectSearch": "ძებნის არჩევა",
  "entity.label.SelectPriority": "პრიორიტეტის არჩევა",
  "entity.label.SelectCategory": "კატეგორიის არჩევა",
  "entity.label.SelectSubCategory": "ქვეკატეგორიის არჩევა",
  "entity.label.SelectSource": "წყაროს არჩევა",
    "entity.label.business_entity_transaction_history":
      "ბიზნეს სუბიექტის ტრანზაქციების ისტორია",
    "entity.label.edit_business_entity": "ბიზნეს სუბიექტის რედაქტირება",
    "entity.label.business_entity": "ბიზნეს ენთიტი",
    "entity.label.business_entity_name": "ბიზნეს სუბიექტის სახელი",
    "entity.label.business_entity_code": "ბიზნეს სუბიექტის კოდი",
    "entity.label.parent_business_entity": "მშობელი ბიზნეს სუბიექტი",
    "entity.label.business_entity_type": "ბიზნეს სუბიექტის ტიპი",
    "entity.label.opened_on": "გახსნილია",
    "entity.label.actions": "ქმედებები",
    "entity.label.clear": "გასუფთავება",
    "entity.label.credit": "კრედიტი",
    "entity.label.create_new_ticket": "ახალი ბილეთის შექმნა",
    "entity.label.cheque_no": "ჩეკის ნომერი",
    "entity.label.from_date": "დაწყების თარიღი",
    "entity.label.to_date": "დასრულების თარიღი",
    "entity.label.filter_by_date": "გაფილტვრა თარიღის მიხედვით",
    "entity.label.start_date": "დაწყების თარიღი",
    "entity.label.end_date": "დასრულების თარიღი",
    "entity.label.search": "ძებნა",
    "entity.label.tree_view": "ხედვა ხელით",
    "entity.label.activity_log": "აქტივობის ჟურნალი",
    "entity.label.create_business_entity": "შექმენით ბიზნეს სუბიექტი",
    "entity.label.business_entity_tree_view": "ბიზნეს სუბიექტის ხე ხედი",
    "entity.label.list_view": "სია ხედი",
    "entity.label.business_entity_opened_on": "ბიზნეს სუბიექტი გაიხსნა",
    "entity.label.relationship_type": "ურთიერთკავების ტიპი",
    "entity.label.business_entity_info": "ბიზნეს სუბიექტის ინფორმაცია",
    "entity.label.company_info": "კომპანიის ინფორმაცია",
    "entity.label.done": "შესრულებულია",
    "entity.label.company_reg_no": "კომპანიის რეესტრაციის ნომერი",
    "entity.label.email": "ელ. ფოსტა",
    "entity.label.payment_type": "გადახდის ტიპი",
    "entity.label.address_name": "მისამართის სახელი",
    "entity.label.segment_type": "სეგმენტის ტიპი",
    "entity.label.city_area": "ქალაქი/რაიონი",
    "entity.label.contact_person": "კონტაქტის პიროვნება",
    "entity.label.district": "რაიონი",
    "entity.label.phone_number": "ტელეფონის ნომერი",
    "entity.label.state": "სახელმწიფო",
    "entity.label.pan_card_no": "Pancard ნომერი",
    "entity.label.country": "ქვეყანა",
    "entity.label.gst_reg_no": "GST რეგისტრაციის ნომერი",
    "entity.label.subscriber_dues": "მფლობელის ვალდებულებები",
    "entity.label.zip_code": "საფოსტო კოდი",
    "entity.label.commission_model": "კომისიის მოდელი",
    "entity.label.successfully_created_business_entity":
      "წარმატებით შეიქმნა ბიზნეს სუბიექტი",
    "entity.label.successfully_edited_business_entity":
      "წარმატებით რედაქტირდა ბიზნეს სუბიექტი",
    "entity.label.go_back_to_business_entity_list":
      "დაუბრუნდით ბიზნეს სუბიექტების სიას",
    "entity.label.cancel": "გაუქმება",
    "entity.label.previous": "წინა",
    "entity.label.next": "შემდეგი",
    "entity.label.submit": "წარმოადგენს",
    "entity.label.view_business_entity": "ბიზნეს სუბიექტის ნახვა",
    "entity.label.add_ticket": "ბილეთის დამატება",
    "entity.label.payments": "გადახდები",
    "entity.label.adjustments": "შესასწორებელი",
    "entity.label.agreements": "ხელშეკრულებები",
    "entity.label.charges": "გადასახადები",
    "entity.label.basic_information": "ძირითადი ინფორმაცია",
    "entity.label.address_information": "მისამართის ინფორმაცია",
    "entity.label.balance": "ბალანსი",
    "entity.label.credit_limit": "კრედიტის ლიმიტი",
    "entity.label.agreement_details": "შეთანხმების დეტალები",
    "entity.label.tickets": "ბილეთები",
    "entity.label.business_entity_disbursements": "ბიზნეს სუბიექტის გაცემა",
    "entity.label.financial_transactions": "ფინანსური ტრანზაქციები",
    "entity.label.customers": "კლიენტები",
    "entity.label.settlement": "გადახდა",
    "entity.label.plan_description": "გეგმის აღწერა",
    "entity.label.contract_end_date": "კონტრაქტის დასრულების თარიღი",
    "entity.label.ticket_number": "ბილეთის ნომერი",
    "entity.label.priority": "პრიორიტეტი",
    "entity.label.ticket_date": "ბილეთის თარიღი",
    "entity.label.problem_code": "პრობლემის კოდი",
    "entity.label.status": "სტატუსი",
    "entity.label.title": "სათაური",
    "entity.label.assign_to": "მიანიჭეთ",
    "entity.label.id": "ID",
    "entity.label.transaction_date": "ტრანზაქციის თარიღი",
    "entity.label.commission_amount": "კომისიის ოდნავა",
    "entity.label.commission_type": "კომისიის ტიპი",
    "entity.label.commission_rate": "კომისიის კურსი",
    "entity.label.transaction_id": "ტრანზაქციის ID",
    "entity.label.transaction_type": "ტრანზაქციის ტიპი",
    "entity.label.amount": "თანხა",
    "entity.label.category": "კატეგორია",
    "entity.label.cancel_remark": "გაუქმების შინაარსი",
    "entity.label.source": "წყარო",
    "entity.label.stb_number": "STB ნომერი",
    "entity.label.customer_number": "კლიენტის ნომერი",
    "entity.label.name": "სახელი",
    "entity.label.mobile_number": "მობილური ნომერი",
    "entity.label.order_number": "შეკვეთის ნომერი",
    "entity.label.active_date": "გააქტიურების თარიღი",
    "entity.label.expiry_date": "ვადა თარიღი",
    "entity.label.balance_amount": "ნაშთის ოდნავა",
    "entity.label.roaming_settlement": "როუმინგის დაგროვება",
    "entity.label.interconnect_settlement": "ინტერკონექტის დაგროვება",
    "entity.label.contract_agreement": "ხელშეკრულება",
    "entity.label.tariff_plan_agreement": "ტარიფის გეგმის ხელშეკრულება",
    "entity.label.new_ticket": "ახალი ბილეთის შექმნა",
    "entity.label.priority": "პრიორიტეტი",
    "entity.label.ticket_date": "ბილეთის თარიღი",
    "entity.label.sub_category": "ქვეკატეგორია",
    "entity.label.due_time": "დასრულების დრო",
    "entity.label.description": "აღწერა",
    "entity.label.save": "შენახვა",
    "entity.label.receipt_no": "მიღების ნომერი",
    "entity.label.payment_date": "გადახდის თარიღი",
    "entity.label.create_payments": "გადახდების შექმნა",
    "entity.label.collection_by": "კოლექცია ან",
    "entity.label.notes": "შენიშვნები",
    "entity.label.is_wallet": "არის საფული",
    "entity.label.bank_name": "ბანკის სახელი",
    "entity.label.branch_name": "ფილიალის სახელი",
    "entity.label.create_adjustment": "ადგილასწორებას შექმნა",
    "entity.label.adjustment_date": "ადგილასწორების თარიღი",
    "entity.label.adjustment_code": "ადგილასწორების კოდი",
    "entity.label.adjustment_amount": "ადგილასწორების ოდენობა",
    "entity.label.adjustment_type": "ადგილასწორების ტიპი",
    "entity.label.view_ticket": "ბილეთის ნახვა",
    "entity.label.close_ticket": "ბილეთის დახურვა",
    "entity.label.edit_ticket": "ბილეთის რედაქტირება",
    "entity.label.last_comment": "ბოლო კომენტარი",
    "entity.label.problem_description": "ამოცანის აღწერა",
    "entity.label.comment_date": "კომენტარის თარიღი",
    "entity.label.file": "ფაილი",
    "entity.label.agreement": "ხელშეკრულება",
    "entity.label.create_agreement": "ხელშეკრულების შექმნა",
    "entity.label.partner_agreement": "პარტნიორის ხელშეკრულება",
    "entity.label.contract_effect_date": "კონტრაქტის ეფექტის თარიღი",
    "entity.label.agreement_date": "ხელშეკრულების თარიღი",
    "entity.label.agreement_status": "ხელშეკრულების სტატუსი",
    "entity.label.agreement_type": "ხელშეკრულების ტიპი",
    "entity.label.business_entity": "ბიზნესის ენთიტეტი",
    "entity.label.business_entity_details": "ბიზნესის ენთიტეტის დეტალები",
    "entity.label.CancelFinancialTransaction": "ფინანსური ტრანზაქციის გაუქმება",
    "entity.label.CancelRemark": "გაუქმების შენიშვნა",
    "entity.label.Save": "შენახვა",
    "entity.label.Cancel": "გაუქმება",
    "entity.label.PartnerAgreement": "პარტნიორის შეთანხმება",
    "entity.label.ContractEffectDate": "შეთანხმების ძალაში შესვლის თარიღი",
    "entity.label.AgreementDate": "შესწორების თარიღი",
    "entity.label.AgreementStatus": "შეთანხმების სტატუსი",
    "entity.label.AgreementType": "შეთანხმების ტიპი",
    "entity.label.AgreementDetails": "შეთანხმების დეტალები",
    "entity.label.ActivityLog": "საქმიანობის ჟურნალი",
    "entity.label.BusinessEntityId": "ბიზნეს ერთეულის ID",
    "entity.label.TransactionDate": "ტრანზაქციის თარიღი",
    "entity.label.TransactionType": "ტრანზაქციის ტიპი",
    "entity.label.History": "ისტორია",
    "entity.label.AdjustmentDate": "შესწორების თარიღი",
    "entity.label.Commission": "კომისია",
    "entity.label.CommissionType": "კომისიის ტიპი",
    "entity.label.Value": "ღირებულება",
    "entity.label.Type": "ტიპი",
    "entity.label.TAPVersion": "TAP ვერსია",
    "entity.label.TAPInSequence": "TAP შემავალი თანმიმდევრობა",
    "entity.label.TAPOutSequence": "TAP გამავალი თანმიმდევრობა",
    "entity.label.RAPInSequence": "RAP შემავალი თანმიმდევრობა",
    "entity.label.RAPOutSequence": "RAP გამავალი თანმიმდევრობა",
    "entity.label.NRTRDEInSequence": "NRTRDE შემავალი თანმიმდევრობა",
    "entity.label.NRTRDEOutSequence": "NRTRDE გამავალი თანმიმდევრობა",
    "entity.label.Configure": "კონფიგურაცია",
    "entity.label.CancelFinancialTransaction": "ფინანსური ტრანზაქციის გაუქმება",
    "entity.label.cancelremark": "გაუქმების შენიშვნა",
    "entity.label.Create_Payment": "გადახდის შექმნა",
  },

  lo: {
    "entity.label.Edit": "ແກ້ໄຂ",
  "entity.label.UpdateCredit": "ອັບເດດເຄຣດິດ",
  "entity.label.AddTicket": "ເພີ່ມບິນ",
  "entity.label.DownloadUploadedFile": "ດາວໂຫຼດໄຟລ໌ທີ່ອັບໂຫຼດ",
  "entity.label.Close": "ປິດ",
  "entity.label.ReopenTicket": "ເປີດບິນໃໝ່",
  "entity.label.ResolutionDescription": "ລາຍລະອຽດການແກ້ໄຂ",
  "entity.label.SelectCategory": "ເລືອກປະເພດ",
  "entity.label.SelectSubCategory": "ເລືອກປະເພດຍ່ອຍ",
  "entity.label.description": "ລາຍລະອຽດ",
  "entity.label.CloseTicket": "ປິດບິນ",
    "entity.label.Commission": "ຄ່າຄະນຳ",
  "entity.label.CommisionType": "ປະເພດຄ່າຄະນຳ",
  "entity.label.Configure": "ກຳນົດຄ່າ",
  "entity.label.Agreement": "ຂໍ້ຕົກລົງ",
  "entity.label.Type": "ປະເພດ",
  "entity.label.TAP_version": "ຮຸ່ນ TAP",
  "entity.label.TAP_In_sequence": "ລຳດັບ TAP ເຂົ້າ",
  "entity.label.TAP_Out_sequence": "ລຳດັບ TAP ອອກ",
  "entity.label.RAP_In_Sequence": "ລຳດັບ RAP ເຂົ້າ",
  "entity.label.RAP_Out_Sequence": "ລຳດັບ RAP ອອກ",
  "entity.label.NRTRDE_In_Sequence": "ລຳດັບ NRTRDE ເຂົ້າ",
  "entity.label.NRTRDE_Out_Sequence": "ລຳດັບ NRTRDE ອອກ",
  "entity.label.In": "ເຂົ້າ",
  "entity.label.Plan": "ແຜນ",
  "entity.label.Out": "ອອກ",
  "entity.label.Cancel": "ຍົກເລີກ",
  "entity.label.Save": "ບັນທຶກ",
    "entity.label.SelectSearch": "ເລືອກການຄົ້ນຫາ",
  "entity.label.SelectPriority": "ເລືອກຄວາມສໍາຄັນ",
  "entity.label.SelectCategory": "ເລືອກປະເພດ",
  "entity.label.SelectSubCategory": "ເລືອກປະເພດຍ່ອຍ",
  "entity.label.SelectSource": "ເລືອກແຫຼ່ງຂໍ້ມູນ",
    "entity.label.business_entity_transaction_history":
      "ປະຫວັດທຸລະກຳຂອງຫົວໜ່ວຍທຸລະກິດ",
    "entity.label.edit_business_entity": "ແກ້ໄຂຫົວໜ່ວຍທຸລະກິດ",
    "entity.label.business_entity": "ການເຮັດຊັນທາງ",
    "entity.label.business_entity_name": "ຊື່ຫົວໜ່ວຍທຸລະກິດ",
    "entity.label.business_entity_code": "ລະຫັດຫົວໜ່ວຍທຸລະກິດ",
    "entity.label.parent_business_entity": "ຫົວໜ່ວຍທຸລະກິດພໍ່ແມ່",
    "entity.label.business_entity_type": "ປະເພດຫົວໜ່ວຍທຸລະກິດ",
    "entity.label.opened_on": "ເປີດເປີດໃຫຍ່ໃນ",
    "entity.label.actions": "ການດຳເນີນການ",
    "entity.label.clear": "ລ້າງ",
    "entity.label.credit": "ເຄຣດິດ",
    "entity.label.create_new_ticket": "ສ້າງປີ້ໃຫມ່",
    "entity.label.cheque_no": "ເລກທີ່ເຊັກ",
    "entity.label.from_date": "ຈາກວັນທີ",
    "entity.label.to_date": "ຫາວັນທີ",
    "entity.label.filter_by_date": "ກັ່ນຕອງຕາມວັນທີ",
    "entity.label.start_date": "ວັນເລີ່ມຕົ້ນ",
    "entity.label.end_date": "ວັນສິ້ນສຸດ",
    "entity.label.search": "ຄົ້ນຫາ",
    "entity.label.tree_view": "ຮູບແບບຮ່າງກາຍ",
    "entity.label.activity_log": "ບັນຊີການເຮັດຊັນ",
    "entity.label.create_business_entity": "ສ້າງຫົວໜ່ວຍທຸລະກິດ",
    "entity.label.business_entity_tree_view": "ມຸມມອງຕົ້ນໄມ້ທຸລະກິດ",
    "entity.label.list_view": "ຮູບແບບລາຍຊື່",
    "entity.label.business_entity_opened_on": "ຫົວໜ່ວຍທຸລະກິດເປີດແລ້ວ",
    "entity.label.relationship_type": "ປະເພດການຕັ້ງເຕືອນ",
    "entity.label.business_entity_info": "ຂໍ້ມູນຫົວໜ່ວຍທຸລະກິດ",
    "entity.label.company_info": "ຂໍ້ມູນຂອງບໍລິສັດ",
    "entity.label.done": "ສໍາເລັດ",
    "entity.label.company_reg_no": "ເລກທະບຽນບໍລິສັດ",
    "entity.label.email": "ອີເມວ",
    "entity.label.payment_type": "ປະເພດການຈ່າຍເງິນ",
    "entity.label.address_name": "ຊື່ທີ່ຢູ່",
    "entity.label.segment_type": "ປະເພດຊາຍແຕ່ງ",
    "entity.label.city_area": "ເມືອງ/ເຂດ",
    "entity.label.contact_person": "ຜູ້ຕິດຕໍ່",
    "entity.label.district": "ເມືອງ",
    "entity.label.phone_number": "ເບີໂທ",
    "entity.label.state": "ແຂວງ",
    "entity.label.pan_card_no": "ເລກບັດປັດສິນ",
    "entity.label.country": "ປະເທດ",
    "entity.label.gst_reg_no": "ເລກສະຖານະ GST",
    "entity.label.subscriber_dues": "ຄ່າໃຊ້ງານຜູ້ຮັບບັນຊີ",
    "entity.label.zip_code": "ລະຫັດໄປສະນີ",
    "entity.label.commission_model": "ໂດຍທົ່ວໄປລົດອັດຕະໂນມັດ",
    "entity.label.successfully_created_business_entity":
      "ສ້າງຫົວໜ່ວຍທຸລະກິດສຳເລັດແລ້ວ",
    "entity.label.successfully_edited_business_entity":
      "ແກ້ໄຂຫົວໜ່ວຍທຸລະກິດສຳເລັດແລ້ວ",
    "entity.label.go_back_to_business_entity_list":
      "ກັບໄປທີ່ລາຍຊື່ຫົວໜ່ວຍທຸລະກິດ",
    "entity.label.cancel": "ຍົກເລີກ",
    "entity.label.previous": "ທີ່ຜ່ານ",
    "entity.label.next": "ຕໍ່ໄປ",
    "entity.label.submit": "ສົ່ງ",
    "entity.label.view_business_entity": "ເບິ່ງຫົວໜ່ວຍທຸລະກິດ",
    "entity.label.add_ticket": "ເພີ່ມໃບປິດ",
    "entity.label.payments": "ການຊຳລະເງິນ",
    "entity.label.adjustments": "ການປັບປ່ຽນ",
    "entity.label.agreements": "ການຄິດເຊັດຄວາມຕ້ອງການ",
    "entity.label.charges": "ຄ່າຈ່າຍ",
    "entity.label.basic_information": "ຂໍ້ມູນພື້ນຖານ",
    "entity.label.address_information": "ຂໍ້ມູນທີ່ຢູ່",
    "entity.label.balance": "ຍອດເຄື່ອງ",
    "entity.label.credit_limit": "ທະນາຄານລູກຄ້າ",
    "entity.label.agreement_details": "ລາຍລະອຽດຂໍ້ມູນຂອງການຮັບການຕໍ່",
    "entity.label.tickets": "ໃບບິນ",
    "entity.label.business_entity_disbursements": "ການເບີກຈ່າຍຫົວໜ່ວຍທຸລະກິດ",
    "entity.label.financial_transactions": "ການເຮັດໃບບິນ",
    "entity.label.customers": "ລູກຄ້າ",
    "entity.label.settlement": "ການຈ່າຍເງິນ",
    "entity.label.plan_description": "ລາຍລະອຽດຂອງໂຄງການ",
    "entity.label.contract_end_date": "ວັນທີ່ສິ້ນສຸດຂອງບໍລິການ",
    "entity.label.ticket_number": "ເລກທີຂອງເບີໂທ",
    "entity.label.priority": "ຄວາມສຳຄັນ",
    "entity.label.ticket_date": "ວັນທີຂອງເບີໂທ",
    "entity.label.problem_code": "ລະຫັດບັນຫາ",
    "entity.label.status": "ສະຖານະ",
    "entity.label.title": "ຫົວຂໍ້",
    "entity.label.assign_to": "ມອບເຖິງ",
    "entity.label.id": "ເລກທີ",
    "entity.label.transaction_date": "ວັນທີຂາຍ",
    "entity.label.commission_amount": "ຈຳນວນຄູ່ຈຳນວນ",
    "entity.label.commission_type": "ປະເພດຄູ່ຈຳນວນ",
    "entity.label.commission_rate": "ອັດຕາລະຫັດ",
    "entity.label.transaction_id": "ID ການເຮັດທຸລະກິດ",
    "entity.label.transaction_type": "ປະເພດການເຮັດທຸລະກິດ",
    "entity.label.amount": "ຈຳນວນ",
    "entity.label.category": "ປະເພດ",
    "entity.label.cancel_remark": "ໝາຍເຫດການຍົກເລີກ",
    "entity.label.source": "ຕົ້ນສະບັບ",
    "entity.label.stb_number": "ເລກທີ່ STB",
    "entity.label.customer_number": "ເລກບຸກຄົນ",
    "entity.label.name": "ຊື່",
    "entity.label.mobile_number": "ເບີໂທລະສັບ",
    "entity.label.order_number": "ເລກລາຍການ",
    "entity.label.active_date": "ວັນທີການເປີດໃຊ້",
    "entity.label.expiry_date": "ວັນໝົດອາຍຸ",
    "entity.label.balance_amount": "ຈຳນວນເງິນຍ່ອຍ",
    "entity.label.roaming_settlement": "ການບັນຊີຄົບຫຼາຍໆ",
    "entity.label.interconnect_settlement": "ການບັນຊີອິນເຕີຂອງການຂາຍສາມາດ",
    "entity.label.contract_agreement": "ການປະຕິບັດຂາຍ",
    "entity.label.tariff_plan_agreement": "ການປະຕິບັດແຜນຕ່າງ",
    "entity.label.new_ticket": "ສ້າງເຄື່ອງມື້ໃຫມ່",
    "entity.label.priority": "ຄວາມສະແດງຄວາມສະແດງ",
    "entity.label.ticket_date": "ວັນທີ່ເຄື່ອງມື້",
    "entity.label.sub_category": "ໝວດໝູ່ບັນຍັດ",
    "entity.label.due_time": "ເວລາທີ່ເຄື່ອງມື້ສຸດ",
    "entity.label.description": "ລາຍລະອຽດ",
    "entity.label.save": "ບັນທຶກ",
    "entity.label.receipt_no": "ເລກໃບຮັບເງິນ",
    "entity.label.payment_date": "ວັນທີຈ່າຍ",
    "entity.label.create_payments": "ສ້າງການຈ່າຍໃຫມ່",
    "entity.label.collection_by": "ຄຸ້ມຄອງໂດຍ",
    "entity.label.notes": "ໝາຍເຫດ",
    "entity.label.is_wallet": "ເປັນບັນຊີ",
    "entity.label.bank_name": "ຊື່ທະນາຄານ",
    "entity.label.branch_name": "ຊື່ບ່ອນປະຈຳປີ",
    "entity.label.create_adjustment": "ສ້າງການປັບມິ່ນ",
    "entity.label.adjustment_date": "ວັນທີປັບມິ່ນ",
    "entity.label.adjustment_code": "ລະຫັດປັບມິ່ນ",
    "entity.label.adjustment_amount": "ຈຳນວນປັບມິ່ນ",
    "entity.label.adjustment_type": "ປະເພດການປັບມິ່ນ",
    "entity.label.view_ticket": "ເບິ່ງຜົນການເຄື່ອງ",
    "entity.label.close_ticket": "ປິດຜົນການເຄື່ອງ",
    "entity.label.edit_ticket": "ແກ້ໄຂຜົນການເຄື່ອງ",
    "entity.label.last_comment": "ຄວາມຄິດເຫັນຫຼ້າສຸດ",
    "entity.label.problem_description": "ລາຍລະອຽດຂອງບັນຫາ",
    "entity.label.comment_date": "ວັນທີຄວາມຄິດເຫັນ",
    "entity.label.file": "ເອກະສານ",
    "entity.label.agreement": "ການຮັບຮອງ",
    "entity.label.create_agreement": "ສ້າງການຮັບຮອງ",
    "entity.label.partner_agreement": "ການຮັບຮອງເທື່ອ",
    "entity.label.contract_effect_date": "ວັນທີຂຽນຂໍ້ມູນສ່ວນບັນດາ",
    "entity.label.agreement_date": "ວັນທີຂຽນການຮັບຮອງ",
    "entity.label.agreement_status": "ສະຖານະການຮັບຮອງ",
    "entity.label.agreement_type": "ປະເພດການຮັບຮອງ",
    "entity.label.business_entity": "ທີ່ສະໜັບສະໜູນທີ່ຂອງທາງຢືນຢັນ",
    "entity.label.business_entity_details":
      "ລາຍລະອຽດຂອງທີ່ສະໜັບສະໜູນທີ່ຂອງທາງຢືນຢັນ",
    "entity.label.CancelFinancialTransaction": "ຍົກເລີກທຸລະກໍາການເງິນ",
    "entity.label.CancelRemark": "ໝາຍເຫດຍົກເລີກ",
    "entity.label.Save": "ບັນທຶກ",
    "entity.label.Cancel": "ຍົກເລີກ",
    "entity.label.PartnerAgreement": "ຂໍ້ຕົກລົງພາກສ່ວນ",
    "entity.label.ContractEffectDate": "ວັນທີເລີ່ມສັນຍາ",
    "entity.label.AgreementDate": "ວັນທີປັບແກ້",
    "entity.label.AgreementStatus": "ສະຖານະຂໍ້ຕົກລົງ",
    "entity.label.AgreementType": "ປະເພດຂໍ້ຕົກລົງ",
    "entity.label.AgreementDetails": "ລາຍລະອຽດຂໍ້ຕົກລົງ",
    "entity.label.ActivityLog": "ບັນທຶກການກະທໍາ",
    "entity.label.BusinessEntityId": "ID ອົງການທຸລະກິດ",
    "entity.label.TransactionDate": "ວັນທີທຸລະກໍາ",
    "entity.label.TransactionType": "ປະເພດທຸລະກໍາ",
    "entity.label.History": "ປະຫວັດສາດ",
    "entity.label.AdjustmentDate": "ວັນທີປັບແກ້",
    "entity.label.Commission": "ຄ່ານາຍໜ້າ",
    "entity.label.CommissionType": "ປະເພດຄ່ານາຍໜ້າ",
    "entity.label.Value": "ມູນຄ່າ",
    "entity.label.Type": "ປະເພດ",
    "entity.label.TAPVersion": "ເວີຊັນ TAP",
    "entity.label.TAPInSequence": "TAP ໃນລຳດັບ",
    "entity.label.TAPOutSequence": "TAP ລຳດັບ",
    "entity.label.RAPInSequence": "RAP ໃນລຳດັບ",
    "entity.label.RAPOutSequence": "RAP ລຳດັບ",
    "entity.label.NRTRDEInSequence": "NRTRDE ໃນລຳດັບ",
    "entity.label.NRTRDEOutSequence": "NRTRDE ລຳດັບ",
    "entity.label.Configure": "ການຕັ້ງຄ່າ",
    "entity.label.CancelFinancialTransaction": "ຍົກເລີກທຸລະກຳເງິນ",
    "entity.label.cancelremark": "ຄໍາເຫັນຍົກເລີກ",
    "entity.label.Create_Payment": "ສ້າງການຊໍາລະເງິນ",
  },

  my_MM: {
    "entity.label.Edit": "ပြင်ဆင်ပါ",
  "entity.label.UpdateCredit": "အကြွေးဘောင်မွမ်းမံပါ",
  "entity.label.AddTicket": "စနစ်ဖြည့်ပါ",
  "entity.label.DownloadUploadedFile": "တင်ထားသောဖိုင်ဒေါင်းလုပ်ပါ",
  "entity.label.Close": "ပိတ်ရန်",
  "entity.label.ReopenTicket": "ပြန်ဖွင့်ပါ",
  "entity.label.ResolutionDescription": "ဖြေရှင်းချက်အကြောင်းအရာ",
  "entity.label.SelectCategory": "အမျိုးအစားရွေးပါ",
  "entity.label.SelectSubCategory": "ခွဲခြားအမျိုးအစားရွေးပါ",
  "entity.label.description": "ဖော်ပြချက်",
  "entity.label.CloseTicket": "အမှုဖိုင်ပိတ်ပါ",
    "entity.label.Commission": "ကော်မရှင်",
  "entity.label.CommisionType": "ကော်မရှင်အမျိုးအစား",
  "entity.label.Configure": "ပြင်ဆင်ပါ",
  "entity.label.Agreement": "သဘောတူညီမှု",
  "entity.label.Type": "အမျိုးအစား",
  "entity.label.TAP_version": "TAP ဗားရှင်း",
  "entity.label.TAP_In_sequence": "TAP ဝင်လိုက်လံမှု",
  "entity.label.TAP_Out_sequence": "TAP ထွက်လိုက်လံမှု",
  "entity.label.RAP_In_Sequence": "RAP ဝင်လိုက်လံမှု",
  "entity.label.RAP_Out_Sequence": "RAP ထွက်လိုက်လံမှု",
  "entity.label.NRTRDE_In_Sequence": "NRTRDE ဝင်လိုက်လံမှု",
  "entity.label.NRTRDE_Out_Sequence": "NRTRDE ထွက်လိုက်လံမှု",
  "entity.label.In": "ဝင်",
  "entity.label.Plan": "အစီအစဉ်",
  "entity.label.Out": "ထွက်",
  "entity.label.Cancel": "ဖျက်သိမ်းမည်",
  "entity.label.Save": "သိမ်းဆည်းမည်",
    "entity.label.SelectSearch": "ရှာဖွေမှုရွေးပါ",
  "entity.label.SelectPriority": "ဦးစားပေးမှုရွေးပါ",
  "entity.label.SelectCategory": "အမျိုးအစားရွေးပါ",
  "entity.label.SelectSubCategory": "ခွဲခြားအမျိုးအစားရွေးပါ",
  "entity.label.SelectSource": "ရင်းမြစ်ရွေးပါ",
    "entity.label.business_entity_transaction_history":
      "လုပ်ငန်းအဖွဲ့အစည်း အရောင်းအ၀ယ်မှတ်တမ်း",
    "entity.label.edit_business_entity": "လုပ်ငန်းအဖွဲ့အစည်းကို တည်းဖြတ်ပါ။",
    "entity.label.business_entity": "စီးပွားရေးအနီးအနား",
    "entity.label.business_entity_name": "လုပ်ငန်းအဖွဲ့အစည်းအမည်",
    "entity.label.business_entity_code": "လုပ်ငန်းဆိုင်ရာ ကုဒ်",
    "entity.label.parent_business_entity": "မိဘလုပ်ငန်းအဖွဲ့အစည်း",
    "entity.label.business_entity_type": "စီးပွားရေးလုပ်ငန်းအမျိုးအစား",
    "entity.label.opened_on": "ဖွင့်ပြီး",
    "entity.label.actions": "လုပ်ဆောင်ချက်များ",
    "entity.label.clear": "ရှင်းလင်းပါ",
    "entity.label.credit": "ခရက်ဒစ်",
    "entity.label.create_new_ticket": "လက်မှတ်အသစ်ဖန်တီးပါ",
    "entity.label.cheque_no": "ချက်နံပါတ်",
    "entity.label.from_date": "စတင်သည့်နေ့",
    "entity.label.to_date": "ဆုံးမည့်နေ့",
    "entity.label.filter_by_date": "နေ့စွဲဖြင့်စစ်ထုတ်ပါ",
    "entity.label.start_date": "အစနေ့",
    "entity.label.end_date": "အဆုံးနေ့",
    "entity.label.search": "ရှာဖွေပါ",
    "entity.label.tree_view": "မီးစက္ကန့်စား",
    "entity.label.activity_log": "လုပ်ဆောင်ချက်မှတ်တမ်း",
    "entity.label.create_business_entity": "စီးပွားရေးလုပ်ငန်းကိုဖန်တီးပါ။",
    "entity.label.business_entity_tree_view": "စီးပွားရေးလုပ်ငန်းသစ်ပင်အမြင်",
    "entity.label.list_view": "စာရင်း ထုတ်လုပ်ရန်",
    "entity.label.business_entity_opened_on":
      "လုပ်ငန်းအဖွဲ့အစည်းကို ဖွင့်ထားသည်။",
    "entity.label.relationship_type": "လွှဲပြီးတောင်းလိုက်သည့်အမျိုးအစား",
    "entity.label.business_entity_info": "လုပ်ငန်းဆိုင်ရာ အချက်အလက်",
    "entity.label.company_info": "ကုမ္ပဏီသည့်အနေအထား",
    "entity.label.done": "ပြီးပြီ",
    "entity.label.company_reg_no": "ကုမ္ပဏီမှတ်ပုံတင်နံပါတ်",
    "entity.label.email": "အီးမေးလိပ်စာ",
    "entity.label.payment_type": "ငွေပေးချေမှုအမျိုးအစား",
    "entity.label.address_name": "လိပ်စာအမည်",
    "entity.label.segment_type": "စီမံခန့်ခွဲမှုအမျိုးအစား",
    "entity.label.city_area": "မြို့/ဧရိယာ",
    "entity.label.contact_person": "ဆက်သွယ်ရန်လိပ်စာ",
    "entity.label.district": "ခရိုင်",
    "entity.label.phone_number": "ဖုန်းနံပါတ်",
    "entity.label.state": "ပြည်နယ်",
    "entity.label.pan_card_no": "ပန်းကတ် နံပါတ်",
    "entity.label.country": "နိုင်ငံ",
    "entity.label.gst_reg_no": "GST မှတ်ပုံတင်နံပါတ်",
    "entity.label.subscriber_dues": "အရောင်းစာရင်းချက်",
    "entity.label.zip_code": "စာတိုက်တန်းကုဒ်",
    "entity.label.commission_model": "ကော်မာကော်အောင်အောင်",
    "entity.label.successfully_created_business_entity":
      "စီးပွားရေးလုပ်ငန်းကို အောင်မြင်စွာ ဖန်တီးခဲ့သည်။",
    "entity.label.successfully_edited_business_entity":
      "လုပ်ငန်းအဖွဲ့အစည်းကို အောင်မြင်စွာ တည်းဖြတ်ခဲ့သည်။",
    "entity.label.go_back_to_business_entity_list":
      "လုပ်ငန်းအဖွဲ့အစည်းစာရင်းသို့ ပြန်သွားပါ။",
    "entity.label.cancel": "ပယ်ဖျက်မည်",
    "entity.label.previous": "နောက်သို့",
    "entity.label.next": "နောက်ဆုံး",
    "entity.label.submit": "တင်သွင်းမည်",
    "entity.label.view_business_entity": "လုပ်ငန်းအဖွဲ့အစည်းကိုကြည့်ပါ။",
    "entity.label.add_ticket": "လုပ်ငန်းထည့်ရန်",
    "entity.label.payments": "ငွေပေးချေမှုများ",
    "entity.label.adjustments": "အသွင်းအပြင်များ",
    "entity.label.agreements": "မှတ်တမ်းများ",
    "entity.label.charges": "ငွေဖြင့်ငွေချေမှုများ",
    "entity.label.basic_information": "အခြေအနေအချက်အလက်",
    "entity.label.address_information": "လိပ်စာအချက်အလက်",
    "entity.label.balance": "လက်ကျန်ငွေ",
    "entity.label.credit_limit": "အာမခံပေးချေမှု",
    "entity.label.agreement_details": "အကောင့်ရှင်းလင်းချက်များ",
    "entity.label.tickets": "လုပ်ငန်းများ",
    "entity.label.business_entity_disbursements":
      "စီးပွားရေးလုပ်ငန်းဆိုင်ရာ ငွေပေးချေမှုများ",
    "entity.label.financial_transactions": "အခြေအနေလုပ်ငန်းများ",
    "entity.label.customers": "ဖောက်သည်များ",
    "entity.label.settlement": "ခြွင်းပြင်မှု",
    "entity.label.plan_description": "အစီအစဉ်ဖော်ပြချက်",
    "entity.label.contract_end_date": "ကွန်ပျူတာသက်တမ်းနေ့",
    "entity.label.ticket_number": "ထုတ်ပြန်သူ့စာရင်း",
    "entity.label.priority": "အရံသို့မဟုတ်ကြောင့်",
    "entity.label.ticket_date": "ထုတ်ပြန်သူ့ရက်စွဲ",
    "entity.label.problem_code": "ပြဿနာကုဒ်",
    "entity.label.status": "အခြေအနေ",
    "entity.label.title": "ခေါင်းစဉ်",
    "entity.label.assign_to": "သတ်မှတ်ပါ",
    "entity.label.id": "ID",
    "entity.label.transaction_date": "ငွေလွှဲပြီးသည့်ရက်",
    "entity.label.commission_amount": "ကော်ပိုင်းပမာဏ",
    "entity.label.commission_type": "ကော်ပိုင်းအမျိုးအစား",
    "entity.label.commission_rate": "ကော်ပိုင်းရောက်",
    "entity.label.transaction_id": "ငွေလွှဲအသစ်",
    "entity.label.transaction_type": "ငွေလွှဲအမျိုးအစား",
    "entity.label.amount": "ငွေပမာဏ",
    "entity.label.category": "အမျိုးအစား",
    "entity.label.cancel_remark": "ပယ်ဖျက်မှုအကြောင်းအရာ",
    "entity.label.source": "ရင်းမြစ်",
    "entity.label.stb_number": "STB နံပါတ်",
    "entity.label.customer_number": "ကောင်းသောအရေအတွက်",
    "entity.label.name": "အမည်",
    "entity.label.mobile_number": "ဖုန်းနံပါတ်",
    "entity.label.order_number": "အမှာစာနံပါတ်",
    "entity.label.active_date": "စတင်မည့်ရက်စွဲ",
    "entity.label.expiry_date": "သက်တမ်းတိုးတက်မည့်ရက်စွဲ",
    "entity.label.balance_amount": "ကျသင့်ငွေပမာဏ",
    "entity.label.roaming_settlement": "ရိုမိုစောင့်မြင်စွာခြေလှမ်းခြင်း",
    "entity.label.interconnect_settlement":
      "ကွန်ပျူတာပါဝါစောင့်မြင်စွာခြေလှမ်းခြင်း",
    "entity.label.contract_agreement": "အက်စ်တွင်ရှိမှုအက်ပ်",
    "entity.label.tariff_plan_agreement": "လစာစာအက်ပ်",
    "entity.label.new_ticket": "ကျပ်သိန်းတာ အသစ် ဖန်တီးရန်",
    "entity.label.priority": "အလုံးစု",
    "entity.label.ticket_date": "ကျပ်သိန်း ရက်စွဲ",
    "entity.label.sub_category": "အမျိုးအစားအရာ",
    "entity.label.due_time": "သတ်မှတ်ချက် အချိန်",
    "entity.label.description": "ဖော်ပြချက်",
    "entity.label.save": "သိမ်းဆည်းရန်",
    "entity.label.receipt_no": "ပြန်လည်နံပါတ်",
    "entity.label.payment_date": "ငွေပေးချေစည်းမှုနေ့",
    "entity.label.create_payments": "ငွေပေးချေစည်းတည်းဖြတ်ရန်",
    "entity.label.collection_by": "ငွေပေးချေစည်းသို့တင်မည်",
    "entity.label.notes": "မှတ်ချက်များ",
    "entity.label.is_wallet": "အကြွေးဝန်ပေးချောင်းမှု",
    "entity.label.bank_name": "ဘဏ်အမည်",
    "entity.label.branch_name": "ဆိုင်အမည်",
    "entity.label.create_adjustment": "အတည်ပြုရန် ဖန်တီးရန်",
    "entity.label.adjustment_date": "အတည်ပြုမည့်ရက်စွဲ",
    "entity.label.adjustment_code": "အတည်ပြုသည့်ကုဒ်",
    "entity.label.adjustment_amount": "အတည်ပြုခြင်းငွေ",
    "entity.label.adjustment_type": "အတည်ပြုအမျိုးအစား",
    "entity.label.view_ticket": "ကြည့်ရန်လှုပ်ရှားလှပ်ရန်",
    "entity.label.close_ticket": "လှုပ်ရန်လှပ်ရန်",
    "entity.label.edit_ticket": "ပြုပြင်နေသည့်လှပ်ရန်ပြုပြင်ရန်",
    "entity.label.last_comment": "နောက်ဆုံးထိမ်းမြောက်ခံ",
    "entity.label.problem_description": "ပြဿနာအကြောင်းအရာ",
    "entity.label.comment_date": "မှတ်ချက်ရက်စွဲ",
    "entity.label.file": "ဖိုင်",
    "entity.label.agreement": "သေချာစွာ",
    "entity.label.create_agreement": "သေချာစွာဖန်တီးရန်",
    "entity.label.partner_agreement": "မိတ်ဖွင့်သောသေချာစွာ",
    "entity.label.contract_effect_date": "စာရင်းသွင်းသည့်နေ့အလွတ်",
    "entity.label.agreement_date": "သေချာစွာရက်စွဲ",
    "entity.label.agreement_status": "သေချာစွာအခြေနေ",
    "entity.label.agreement_type": "သေချာစွာအမျိုးအစား",
    "entity.label.business_entity": "ဘောင်ချာနှစ်ဖွင့်တည်း",
    "entity.label.business_entity_details": "ဘောင်ချာနှစ်ဖွင့်တည်းအသေးစိတ်",
    "entity.label.CancelFinancialTransaction": "ငွေလွှဲခြင်းကိုဖျက်သိမ်းရန်",
    "entity.label.CancelRemark": "မှတ်ချက်ဖျက်သိမ်းခြင်း",
    "entity.label.Save": "သိမ်းဆည်းမည်",
    "entity.label.Cancel": "ဖျက်သိမ်းမည်",
    "entity.label.PartnerAgreement": "အခွန်ကင်းလွတ်ခွင့်",
    "entity.label.ContractEffectDate": "စာချုပ်အကျုံးဝင်ရက်",
    "entity.label.AgreementDate": "ချိန်ညှိသည့်ရက်စွဲ",
    "entity.label.AgreementStatus": "စာချုပ်အခြေအနေ",
    "entity.label.AgreementType": "စာချုပ်အမျိုးအစား",
    "entity.label.AgreementDetails": "စာချုပ်အသေးစိတ်",
    "entity.label.ActivityLog": "လှုပ်ရှားမှုမှတ်တမ်း",
    "entity.label.BusinessEntityId": "စီးပွားရေးအဖွဲ့အစည်း ID",
    "entity.label.TransactionDate": "ငွေလွှဲရက်စွဲ",
    "entity.label.TransactionType": "ငွေလွှဲအမျိုးအစား",
    "entity.label.History": "သမိုင်း",
    "entity.label.AdjustmentDate": "ချိန်ညှိသည့်ရက်စွဲ",
    "entity.label.Commission": "ကော်မရှင်",
    "entity.label.CommissionType": "ကော်မရှင်အမျိုးအစား",
    "entity.label.Value": "တန်ဖိုး",
    "entity.label.Type": "အမျိုးအစား",
    "entity.label.TAPVersion": "TAP ဗားရှင်း",
    "entity.label.TAPInSequence": "TAP အတွင်းအစီအစဉ်",
    "entity.label.TAPOutSequence": "TAP အပြင်အစီအစဉ်",
    "entity.label.RAPInSequence": "RAP အတွင်းအစီအစဉ်",
    "entity.label.RAPOutSequence": "RAP အပြင်အစီအစဉ်",
    "entity.label.NRTRDEInSequence": "NRTRDE အတွင်းအစီအစဉ်",
    "entity.label.NRTRDEOutSequence": "NRTRDE အပြင်အစီအစဉ်",
    "entity.label.Configure": "ဖွဲ့စည်းပါ",
    "entity.label.CancelFinancialTransaction": "ဘဏ္ဍာရေးငွေလွှဲကို ဖျက်သိမ်းပါ",
    "entity.label.cancelremark": "ဖျက်သိမ်းမှတ်ချက်",
    "entity.label.Create_Payment": "ငွေပေးချေမှု ဖန်တီးပါ",
  },

  my: {
    "entity.label.Edit": "ပြင်ဆင်ပါ",
  "entity.label.UpdateCredit": "အကြွေးဘောင်မွမ်းမံပါ",
  "entity.label.AddTicket": "စနစ်ဖြည့်ပါ",
  "entity.label.DownloadUploadedFile": "တင်ထားသောဖိုင်ဒေါင်းလုပ်ပါ",
  "entity.label.Close": "ပိတ်ရန်",
  "entity.label.ReopenTicket": "ပြန်ဖွင့်ပါ",
  "entity.label.ResolutionDescription": "ဖြေရှင်းချက်အကြောင်းအရာ",
  "entity.label.SelectCategory": "အမျိုးအစားရွေးပါ",
  "entity.label.SelectSubCategory": "ခွဲခြားအမျိုးအစားရွေးပါ",
  "entity.label.description": "ဖော်ပြချက်",
  "entity.label.CloseTicket": "အမှုဖိုင်ပိတ်ပါ",
    "entity.label.Commission": "ေကာ္မရွင္",
  "entity.label.CommisionType": "ေကာ္မရွင္အမ်ိဳးအစား",
  "entity.label.Configure": "ျပင္ဆင္ပါ",
  "entity.label.Agreement": "သေဘာတူညီမႈ",
  "entity.label.Type": "အမ်ိဳးအစား",
  "entity.label.TAP_version": "TAP ဗားရွင္း",
  "entity.label.TAP_In_sequence": "TAP ဝင္လိုက္လံမႈ",
  "entity.label.TAP_Out_sequence": "TAP ထြက္လိုက္လံမႈ",
  "entity.label.RAP_In_Sequence": "RAP ဝင္လိုက္လံမႈ",
  "entity.label.RAP_Out_Sequence": "RAP ထြက္လိုက္လံမႈ",
  "entity.label.NRTRDE_In_Sequence": "NRTRDE ဝင္လိုက္လံမႈ",
  "entity.label.NRTRDE_Out_Sequence": "NRTRDE ထြက္လိုက္လံမႈ",
  "entity.label.In": "ဝင္",
  "entity.label.Plan": "အစီအစဥ္",
  "entity.label.Out": "ထြက္",
  "entity.label.Cancel": "ဖ်က္သိမ္းမည္",
  "entity.label.Save": "သိမ္းဆည္းမည္",
    "entity.label.SelectSearch": "ရှာဖွေမှုရွေးပါ",
  "entity.label.SelectPriority": "ဦးစားပေးမှုရွေးပါ",
  "entity.label.SelectCategory": "အမျိုးအစားရွေးပါ",
  "entity.label.SelectSubCategory": "ခွဲခြားအမျိုးအစားရွေးပါ",
  "entity.label.SelectSource": "ရင်းမြစ်ရွေးပါ",
    "entity.label.business_entity_transaction_history":
      "လုပ်ငန်းအဖွဲ့အစည်း အရောင်းအ၀ယ်မှတ်တမ်း",
    "entity.label.edit_business_entity": "လုပ်ငန်းအဖွဲ့အစည်းကို တည်းဖြတ်ပါ။",
    "entity.label.business_entity": "စီးပွားရေးအနီးအနား",
    "entity.label.business_entity_name": "လုပ်ငန်းအဖွဲ့အစည်းအမည်",
    "entity.label.business_entity_code": "လုပ်ငန်းဆိုင်ရာ ကုဒ်",
    "entity.label.parent_business_entity": "မိဘလုပ်ငန်းအဖွဲ့အစည်း",
    "entity.label.business_entity_type": "စီးပွားရေးလုပ်ငန်းအမျိုးအစား",
    "entity.label.opened_on": "ဖွင့်ပြီး",
    "entity.label.actions": "လုပ်ဆောင်ချက်များ",
    "entity.label.clear": "ရှင်းလင်းရန်",
    "entity.label.credit": "အကြွေး",
    "entity.label.create_new_ticket": "လက်မှတ်အသစ် ဖန်တီးရန်",
    "entity.label.cheque_no": "ချက်နံပါတ်",
    "entity.label.from_date": "စတင်နေ့",
    "entity.label.to_date": "ပြီးဆုံးနေ့",
    "entity.label.filter_by_date": "နေ့စွဲဖြင့် စစ်ထုတ်ရန်",
    "entity.label.start_date": "အစနေ့",
    "entity.label.end_date": "အဆုံးနေ့",
    "entity.label.search": "ရှာဖွေရန်",
    "entity.label.tree_view": "မီးစက္ကန့်စား",
    "entity.label.activity_log": "လုပ်ဆောင်ချက်မှတ်တမ်း",
    "entity.label.create_business_entity": "စီးပွားရေးလုပ်ငန်းကိုဖန်တီးပါ။",
    "entity.label.business_entity_tree_view": "စီးပွားရေးလုပ်ငန်းသစ်ပင်အမြင်",
    "entity.label.list_view": "စာရင်း ထုတ်လုပ်ရန်",
    "entity.label.business_entity_opened_on":
      "လုပ်ငန်းအဖွဲ့အစည်းကို ဖွင့်ထားသည်။",
    "entity.label.relationship_type": "လွှဲပြီးတောင်းလိုက်သည့်အမျိုးအစား",
    "entity.label.business_entity_info": "လုပ်ငန်းဆိုင်ရာ အချက်အလက်",
    "entity.label.company_info": "ကုမ္ပဏီသည့်အနေအထား",
    "entity.label.done": "ပြီးပြီ",
    "entity.label.company_reg_no": "ကုမ္ပဏီမှတ်ပုံတင်နံပါတ်",
    "entity.label.email": "အီးမေးလိပ်စာ",
    "entity.label.payment_type": "ငွေပေးချေမှုအမျိုးအစား",
    "entity.label.address_name": "လိပ်စာအမည်",
    "entity.label.segment_type": "စီမံခန့်ခွဲမှုအမျိုးအစား",
    "entity.label.city_area": "မြို့/ဧရိယာ",
    "entity.label.contact_person": "ဆက်သွယ်ရန်လိပ်စာ",
    "entity.label.district": "ခရိုင်",
    "entity.label.phone_number": "ဖုန်းနံပါတ်",
    "entity.label.state": "ပြည်နယ်",
    "entity.label.pan_card_no": "ပန်းကတ် နံပါတ်",
    "entity.label.country": "နိုင်ငံ",
    "entity.label.gst_reg_no": "GST မှတ်ပုံတင်နံပါတ်",
    "entity.label.subscriber_dues": "အရောင်းစာရင်းချက်",
    "entity.label.zip_code": "စာတိုက်တန်းကုဒ်",
    "entity.label.commission_model": "ကော်မာကော်အောင်အောင်",
    "entity.label.successfully_created_business_entity":
      "စီးပွားရေးလုပ်ငန်းကို အောင်မြင်စွာ ဖန်တီးခဲ့သည်။",
    "entity.label.successfully_edited_business_entity":
      "လုပ်ငန်းအဖွဲ့အစည်းကို အောင်မြင်စွာ တည်းဖြတ်ခဲ့သည်။",
    "entity.label.go_back_to_business_entity_list":
      "လုပ်ငန်းအဖွဲ့အစည်းစာရင်းသို့ ပြန်သွားပါ။",
    "entity.label.cancel": "ပယ်ဖျက်မည်",
    "entity.label.previous": "နောက်သို့",
    "entity.label.next": "နောက်ဆုံး",
    "entity.label.submit": "တင်သွင်းမည်",
    "entity.label.view_business_entity": "လုပ်ငန်းအဖွဲ့အစည်းကိုကြည့်ပါ။",
    "entity.label.add_ticket": "လုပ်ငန်းထည့်ရန်",
    "entity.label.payments": "ငွေပေးချေမှုများ",
    "entity.label.adjustments": "အသွင်းအပြင်များ",
    "entity.label.agreements": "မှတ်တမ်းများ",
    "entity.label.charges": "ငွေဖြင့်ငွေချေမှုများ",
    "entity.label.basic_information": "အခြေအနေအချက်အလက်",
    "entity.label.address_information": "လိပ်စာအချက်အလက်",
    "entity.label.balance": "လက်ကျန်ငွေ",
    "entity.label.credit_limit": "အာမခံပေးချေမှု",
    "entity.label.agreement_details": "အကောင့်ရှင်းလင်းချက်များ",
    "entity.label.tickets": "လုပ်ငန်းများ",
    "entity.label.business_entity_disbursements":
      "စီးပွားရေးလုပ်ငန်းဆိုင်ရာ ငွေပေးချေမှုများး",
    "entity.label.financial_transactions": "အခြေအနေလုပ်ငန်းများ",
    "entity.label.customers": "ဖောက်သည်များ",
    "entity.label.settlement": "ခြွင်းပြင်မှု",
    "entity.label.plan_description": "အစီအစဉ်ဖော်ပြချက်",
    "entity.label.contract_end_date": "ကွန်ပျူတာသက်တမ်းနေ့",
    "entity.label.ticket_number": "ထုတ်ပြန်သူ့စာရင်း",
    "entity.label.priority": "အရံသို့မဟုတ်ကြောင့်",
    "entity.label.ticket_date": "ထုတ်ပြန်သူ့ရက်စွဲ",
    "entity.label.problem_code": "ပြဿနာကုဒ်",
    "entity.label.status": "အခြေအနေ",
    "entity.label.title": "ခေါင်းစဉ်",
    "entity.label.assign_to": "သတ်မှတ်ပါ",
    "entity.label.id": "ID",
    "entity.label.transaction_date": "ငွေလွှဲပြီးသည့်ရက်",
    "entity.label.commission_amount": "ကော်ပိုင်းပမာဏ",
    "entity.label.commission_type": "ကော်ပိုင်းအမျိုးအစား",
    "entity.label.commission_rate": "ကော်ပိုင်းရောက်",
    "entity.label.transaction_id": "ငွေလွှဲအသစ်",
    "entity.label.transaction_type": "ငွေလွှဲအမျိုးအစား",
    "entity.label.amount": "ငွေပမာဏ",
    "entity.label.category": "အမျိုးအစား",
    "entity.label.cancel_remark": "ပယ်ဖျက်မှုအကြောင်းအရာ",
    "entity.label.source": "ရင်းမြစ်",
    "entity.label.stb_number": "STB နံပါတ်",
    "entity.label.customer_number": "ကောင်းသောအရေအတွက်",
    "entity.label.name": "အမည်",
    "entity.label.mobile_number": "ဖုန်းနံပါတ်",
    "entity.label.order_number": "အမှာစာနံပါတ်",
    "entity.label.active_date": "စတင်မည့်ရက်စွဲ",
    "entity.label.expiry_date": "သက်တမ်းတိုးတက်မည့်ရက်စွဲ",
    "entity.label.balance_amount": "ကျသင့်ငွေပမာဏ",
    "entity.label.roaming_settlement": "ရိုမိုစောင့်မြင်စွာခြေလှမ်းခြင်း",
    "entity.label.interconnect_settlement":
      "ကွန်ပျူတာပါဝါစောင့်မြင်စွာခြေလှမ်းခြင်း",
    "entity.label.contract_agreement": "အက်စ်တွင်ရှိမှုအက်ပ်",
    "entity.label.tariff_plan_agreement": "လစာစာအက်ပ်",
    "entity.label.new_ticket": "ကျပ်သိန်း အသစ် ဖန်တီးရန်",
    "entity.label.priority": "အလုံးစု",
    "entity.label.ticket_date": "ကျပ်သိန်း ရက်စွဲ",
    "entity.label.sub_category": "အမျိုးအစားအရာ",
    "entity.label.due_time": "သတ်မှတ်ချက် အချိန်",
    "entity.label.description": "ဖော်ပြချက်",
    "entity.label.save": "သိမ်းဆည်းရန်",
    "entity.label.receipt_no": "ပြန်လည်နံပါတ်",
    "entity.label.payment_date": "ငွေပေးချေစည်းမှုနေ့",
    "entity.label.create_payments": "ငွေပေးချေစည်းတည်းဖြတ်ရန်",
    "entity.label.collection_by": "ငွေပေးချေစည်းသို့တင်မည်",
    "entity.label.notes": "မှတ်ချက်များ",
    "entity.label.is_wallet": "အကြွေးဝန်ပေးချောင်းမှု",
    "entity.label.bank_name": "ဘဏ်အမည်",
    "entity.label.branch_name": "ဆိုင်အမည်",
    "entity.label.create_adjustment": "အတည်ပြုရန် ဖန်တီးရန်",
    "entity.label.adjustment_date": "အတည်ပြုမည့်ရက်စွဲ",
    "entity.label.adjustment_code": "အတည်ပြုသည့်ကုဒ်",
    "entity.label.adjustment_amount": "အတည်ပြုခြင်းငွေ",
    "entity.label.adjustment_type": "အတည်ပြုအမျိုးအစား",
    "entity.label.view_ticket": "ကြည့်ရန်လှုပ်ရှားလှပ်ရန်",
    "entity.label.close_ticket": "လှုပ်ရန်လှပ်ရန်",
    "entity.label.edit_ticket": "ပြုပြင်နေသည့်လှပ်ရန်ပြုပြင်ရန်",
    "entity.label.last_comment": "နောက်ဆုံးထိမ်းမြောက်ခံ",
    "entity.label.problem_description": "ပြဿနာအကြောင်းအရာ",
    "entity.label.comment_date": "မှတ်ချက်ရက်စွဲ",
    "entity.label.file": "ဖိုင်",
    "entity.label.agreement": "သေချာစွာ",
    "entity.label.create_agreement": "သေချာစွာဖန်တီးရန်",
    "entity.label.partner_agreement": "မိတ်ဖွင့်သောသေချာစွာ",
    "entity.label.contract_effect_date": "စာရင်းသွင်းသည့်နေ့အလွတ်",
    "entity.label.agreement_date": "သေချာစွာရက်စွဲ",
    "entity.label.agreement_status": "သေချာစွာအခြေနေ",
    "entity.label.agreement_type": "သေချာစွာအမျိုးအစား",
    "entity.label.business_entity": "ဘောင်ချာနှစ်ဖွင့်တည်း",
    "entity.label.business_entity_details": "ဘောင်ချာနှစ်ဖွင့်တည်းအသေးစိတ်",
    "entity.label.CancelFinancialTransaction": "ငွေလွှဲခြင်းကိုဖျက်သိမ်းရန်",
    "entity.label.CancelRemark": "မှတ်ချက်ဖျက်သိမ်းခြင်း",
    "entity.label.Save": "သိမ်းဆည်းမည်",
    "entity.label.Cancel": "ဖျက်သိမ်းမည်",
    "entity.label.PartnerAgreement": "အခွန်ကင်းလွတ်ခွင့်",
    "entity.label.ContractEffectDate": "စာချုပ်အကျုံးဝင်ရက်",
    "entity.label.AgreementDate": "ချိန်ညှိသည့်ရက်စွဲ",
    "entity.label.AgreementStatus": "စာချုပ်အခြေအနေ",
    "entity.label.AgreementType": "စာချုပ်အမျိုးအစား",
    "entity.label.AgreementDetails": "စာချုပ်အသေးစိတ်",
    "entity.label.ActivityLog": "လှုပ်ရှားမှုမှတ်တမ်း",
    "entity.label.BusinessEntityId": "စီးပွားရေးအဖွဲ့အစည်း ID",
    "entity.label.TransactionDate": "ငွေလွှဲရက်စွဲ",
    "entity.label.TransactionType": "ငွေလွှဲအမျိုးအစား",
    "entity.label.History": "သမိုင်း",
    "entity.label.AdjustmentDate": "ချိန်ညှိသည့်ရက်စွဲ",
    "entity.label.Commission": "ကော်မရှင်",
    "entity.label.CommissionType": "ကော်မရှင်အမျိုးအစား",
    "entity.label.Value": "တန်ဖိုး",
    "entity.label.Type": "အမျိုးအစား",
    "entity.label.TAPVersion": "TAP ဗားရှင်း",
    "entity.label.TAPInSequence": "TAP အတွင်းအစီအစဉ်",
    "entity.label.TAPOutSequence": "TAP အပြင်အစီအစဉ်",
    "entity.label.RAPInSequence": "RAP အတွင်းအစီအစဉ်",
    "entity.label.RAPOutSequence": "RAP အပြင်အစီအစဉ်",
    "entity.label.NRTRDEInSequence": "NRTRDE အတွင်းအစီအစဉ်",
    "entity.label.NRTRDEOutSequence": "NRTRDE အပြင်အစီအစဉ်",
    "entity.label.Configure": "ဖွဲ့စည်းပါ",
    "entity.label.CancelFinancialTransaction": "ဘဏ္ဍာရေးငွေလွှဲကို ဖျက်သိမ်းပါ",
    "entity.label.cancelremark": "ဖျက်သိမ်းမှတ်ချက်",
    "entity.label.Create_Payment": "ငွေပေးချေမှု ဖန်တီးပါ",
  },

  vi: {
    "entity.label.Edit": "Chỉnh sửa",
  "entity.label.UpdateCredit": "Cập nhật tín dụng",
  "entity.label.AddTicket": "Thêm phiếu",
  "entity.label.DownloadUploadedFile": "Tải xuống tệp đã tải lên",
  "entity.label.Close": "Đóng",
  "entity.label.ReopenTicket": "Mở lại phiếu",
  "entity.label.ResolutionDescription": "Mô tả giải pháp",
  "entity.label.SelectCategory": "Chọn danh mục",
  "entity.label.SelectSubCategory": "Chọn danh mục con",
  "entity.label.description": "Mô tả",
  "entity.label.CloseTicket": "Đóng phiếu",
    "entity.label.Commission": "Hoa hồng",
  "entity.label.CommisionType": "Loại hoa hồng",
  "entity.label.Configure": "Cấu hình",
  "entity.label.Agreement": "Thỏa thuận",
  "entity.label.Type": "Loại",
  "entity.label.TAP_version": "Phiên bản TAP",
  "entity.label.TAP_In_sequence": "Chuỗi TAP vào",
  "entity.label.TAP_Out_sequence": "Chuỗi TAP ra",
  "entity.label.RAP_In_Sequence": "Chuỗi RAP vào",
  "entity.label.RAP_Out_Sequence": "Chuỗi RAP ra",
  "entity.label.NRTRDE_In_Sequence": "Chuỗi NRTRDE vào",
  "entity.label.NRTRDE_Out_Sequence": "Chuỗi NRTRDE ra",
  "entity.label.In": "Vào",
  "entity.label.Plan": "Kế hoạch",
  "entity.label.Out": "Ra",
  "entity.label.Cancel": "Hủy bỏ",
  "entity.label.Save": "Lưu",
    "entity.label.SelectSearch": "Chọn tìm kiếm",
  "entity.label.SelectPriority": "Chọn mức ưu tiên",
  "entity.label.SelectCategory": "Chọn danh mục",
  "entity.label.SelectSubCategory": "Chọn danh mục con",
  "entity.label.SelectSource": "Chọn nguồn",
    "entity.label.business_entity_transaction_history":
      "Lịch sử giao dịch của thực thể kinh doanh",
    "entity.label.edit_business_entity": "Chỉnh sửa thực thể kinh doanh",
    "entity.label.business_entity": "Thực thể kinh doanh",
    "entity.label.business_entity_name": "Tên pháp nhân kinh doanh",
    "entity.label.business_entity_code": "Mã thực thể kinh doanh",
    "entity.label.parent_business_entity": "Thực thể kinh doanh mẹ",
    "entity.label.business_entity_type": "Loại thực thể kinh doanh",
    "entity.label.opened_on": "Được mở vào",
    "entity.label.actions": "Hành động",
    "entity.label.clear": "Xóa",
    "entity.label.credit": "Tín dụng",
    "entity.label.create_new_ticket": "Tạo vé mới",
    "entity.label.cheque_no": "Số séc",
    "entity.label.from_date": "Từ ngày",
    "entity.label.to_date": "Đến ngày",
    "entity.label.filter_by_date": "Lọc theo ngày",
    "entity.label.start_date": "Ngày bắt đầu",
    "entity.label.end_date": "Ngày kết thúc",
    "entity.label.search": "Tìm kiếm",
    "entity.label.tree_view": "Xem cây",
    "entity.label.activity_log": "Nhật ký hoạt động",
    "entity.label.create_business_entity": "tạo thực thể kinh doanh",
    "entity.label.business_entity_tree_view":
      "chế độ xem dạng cây thực thể doanh nghiệp",
    "entity.label.list_view": "Xem danh sách",
    "entity.label.business_entity_opened_on":
      "Thực thể kinh doanh được mở vào ngày",
    "entity.label.relationship_type": "Loại mối quan hệ",
    "entity.label.business_entity_info": "Thông tin thực thể doanh nghiệp",
    "entity.label.company_info": "Thông tin công ty",
    "entity.label.done": "Hoàn thành",
    "entity.label.company_reg_no": "Số Đăng ký Công ty",
    "entity.label.email": "Email",
    "entity.label.payment_type": "Loại thanh toán",
    "entity.label.address_name": "Tên địa chỉ",
    "entity.label.segment_type": "Loại phân khúc",
    "entity.label.city_area": "Thành phố/Khu vực",
    "entity.label.contact_person": "Người liên hệ",
    "entity.label.district": "Quận/Huyện",
    "entity.label.phone_number": "Số điện thoại",
    "entity.label.state": "Bang",
    "entity.label.pan_card_no": "Số thẻ Pan",
    "entity.label.country": "Quốc gia",
    "entity.label.gst_reg_no": "Số đăng ký GST",
    "entity.label.subscriber_dues": "Cước phí của người đăng ký",
    "entity.label.zip_code": "Mã bưu chính",
    "entity.label.commission_model": "Mô hình hoa hồng",
    "entity.label.successfully_created_business_entity":
      "Thực thể kinh doanh được tạo thành công",
    "entity.label.successfully_edited_business_entity":
      "Đã chỉnh sửa thành công pháp nhân doanh nghiệp",
    "entity.label.go_back_to_business_entity_list":
      "Quay lại danh sách thực thể doanh nghiệp",
    "entity.label.cancel": "Hủy bỏ",
    "entity.label.previous": "Trước",
    "entity.label.next": "Tiếp theo",
    "entity.label.submit": "Gửi",
    "entity.label.view_business_entity": "Xem thực thể kinh doanh",
    "entity.label.add_ticket": "Thêm Ticket",
    "entity.label.payments": "Thanh toán",
    "entity.label.adjustments": "Điều chỉnh",
    "entity.label.agreements": "Thỏa thuận",
    "entity.label.charges": "Phí",
    "entity.label.basic_information": "Thông tin Cơ bản",
    "entity.label.address_information": "Thông tin Địa chỉ",
    "entity.label.balance": "Số dư",
    "entity.label.credit_limit": "Hạn mức tín dụng",
    "entity.label.agreement_details": "Chi tiết hợp đồng",
    "entity.label.tickets": "Vé",
    "entity.label.business_entity_disbursements":
      "Giải ngân của tổ chức kinh doanh",
    "entity.label.financial_transactions": "Giao dịch tài chính",
    "entity.label.customers": "Khách hàng",
    "entity.label.settlement": "Thanh toán",
    "entity.label.plan_description": "Mô tả Kế hoạch",
    "entity.label.contract_end_date": "Ngày Kết thúc Hợp đồng",
    "entity.label.ticket_number": "Số Ticket",
    "entity.label.priority": "Ưu tiên",
    "entity.label.ticket_date": "Ngày Ticket",
    "entity.label.problem_code": "Mã vấn đề",
    "entity.label.status": "Trạng thái",
    "entity.label.title": "Tiêu đề",
    "entity.label.assign_to": "Giao cho",
    "entity.label.id": "ID",
    "entity.label.transaction_date": "Ngày Giao dịch",
    "entity.label.commission_amount": "Số Tiền Hoa Hồng",
    "entity.label.commission_type": "Loại Hoa Hồng",
    "entity.label.commission_rate": "Tỷ lệ Hoa Hồng",
    "entity.label.transaction_id": "ID Giao dịch",
    "entity.label.transaction_type": "Loại Giao dịch",
    "entity.label.amount": "Số Tiền",
    "entity.label.category": "Danh mục",
    "entity.label.cancel_remark": "Ghi chú Hủy",
    "entity.label.source": "Nguồn",
    "entity.label.stb_number": "Số STB",
    "entity.label.customer_number": "Số Khách hàng",
    "entity.label.name": "Tên",
    "entity.label.mobile_number": "Số Điện thoại Di động",
    "entity.label.order_number": "Số Đơn hàng",
    "entity.label.active_date": "Ngày Kích hoạt",
    "entity.label.expiry_date": "Ngày Hết hạn",
    "entity.label.balance_amount": "Số Dư Tài khoản",
    "entity.label.roaming_settlement": "Thanh toán Roaming",
    "entity.label.interconnect_settlement": "Thanh toán Liên kết",
    "entity.label.contract_agreement": "Thỏa thuận Hợp đồng",
    "entity.label.tariff_plan_agreement": "Thỏa thuận Kế hoạch Giá cước",
    "entity.label.new_ticket": "Tạo Ticket Mới",
    "entity.label.priority": "Độ Ưu Tiên",
    "entity.label.ticket_date": "Ngày Ticket",
    "entity.label.sub_category": "Danh Mục Con",
    "entity.label.due_time": "Thời Gian Đáo Hạn",
    "entity.label.description": "Mô Tả",
    "entity.label.save": "Lưu",
    "entity.label.receipt_no": "Số Hóa Đơn",
    "entity.label.payment_date": "Ngày Thanh Toán",
    "entity.label.create_payments": "Tạo Thanh Toán",
    "entity.label.collection_by": "Thu Thập Bởi",
    "entity.label.notes": "Ghi Chú",
    "entity.label.is_wallet": "Là Ví",
    "entity.label.bank_name": "Tên Ngân Hàng",
    "entity.label.branch_name": "Tên Chi Nhánh",
    "entity.label.create_adjustment": "Tạo Điều Chỉnh",
    "entity.label.adjustment_date": "Ngày Điều Chỉnh",
    "entity.label.adjustment_code": "Mã Điều Chỉnh",
    "entity.label.adjustment_amount": "Số Tiền Điều Chỉnh",
    "entity.label.adjustment_type": "Loại Điều Chỉnh",
    "entity.label.view_ticket": "Xem Ticket",
    "entity.label.close_ticket": "Đóng Ticket",
    "entity.label.edit_ticket": "Chỉnh sửa Ticket",
    "entity.label.last_comment": "Bình luận Cuối cùng",
    "entity.label.problem_description": "Mô tả Vấn đề",
    "entity.label.comment_date": "Ngày Bình luận",
    "entity.label.file": "Tệp",
    "entity.label.agreement": "Thỏa thuận",
    "entity.label.create_agreement": "Tạo Thỏa thuận",
    "entity.label.partner_agreement": "Thỏa thuận Đối tác",
    "entity.label.contract_effect_date": "Ngày Hiệu lực Hợp đồng",
    "entity.label.agreement_date": "Ngày Thỏa thuận",
    "entity.label.agreement_status": "Tình trạng Thỏa thuận",
    "entity.label.agreement_type": "Loại Thỏa thuận",
    "entity.label.business_entity": "Thực thể kinh doanh",
    "entity.label.business_entity_details": "Chi tiết thực thể kinh doanh",
    "entity.label.CancelFinancialTransaction": "Hủy Giao Dịch Tài Chính",
    "entity.label.CancelRemark": "Nhận Xét Hủy",
    "entity.label.Save": "Lưu",
    "entity.label.Cancel": "Hủy",
    "entity.label.PartnerAgreement": "Thỏa Thuận Đối Tác",
    "entity.label.ContractEffectDate": "Ngày Hiệu Lực Hợp Đồng",
    "entity.label.AgreementDate": "Ngày Điều Chỉnh",
    "entity.label.AgreementStatus": "Trạng Thái Thỏa Thuận",
    "entity.label.AgreementType": "Loại Thỏa Thuận",
    "entity.label.AgreementDetails": "Chi Tiết Thỏa Thuận",
    "entity.label.ActivityLog": "Nhật Ký Hoạt Động",
    "entity.label.BusinessEntityId": "ID Thực Thể Kinh Doanh",
    "entity.label.TransactionDate": "Ngày Giao Dịch",
    "entity.label.TransactionType": "Loại Giao Dịch",
    "entity.label.History": "Lịch Sử",
    "entity.label.AdjustmentDate": "Ngày Điều Chỉnh",
    "entity.label.Commission": "Hoa Hồng",
    "entity.label.CommissionType": "Loại Hoa Hồng",
    "entity.label.Value": "Giá Trị",
    "entity.label.Type": "Loại",
    "entity.label.TAPVersion": "Phiên Bản TAP",
    "entity.label.TAPInSequence": "Chuỗi Nhập TAP",
    "entity.label.TAPOutSequence": "Chuỗi Xuất TAP",
    "entity.label.RAPInSequence": "Chuỗi Nhập RAP",
    "entity.label.RAPOutSequence": "Chuỗi Xuất RAP",
    "entity.label.NRTRDEInSequence": "Chuỗi Nhập NRTRDE",
    "entity.label.NRTRDEOutSequence": "Chuỗi Xuất NRTRDE",
    "entity.label.Configure": "Cấu Hình",
    "entity.label.CancelFinancialTransaction": "Hủy Giao Dịch Tài Chính",
    "entity.label.cancelremark": "Ghi Chú Hủy",
    "entity.label.Create_Payment": "Tạo Thanh Toán",
  },
};
